<template>
  <div class="Kanit BGwhite">
    <v-card-text style="margin-top:0vh; margin-bottom:0vh; justify-content: center !important; color: rgb(74, 74, 74) !important;">
      <v-container grid-list-md v-if="stateProcess=='showDetail'">
        <v-layout wrap>
          <v-flex sm12 md12 lg12 xl12 style="display: flex; justify-content: center; margin-top: -4vh;">
            <v-container grid-list-md class="mt-2">
              <v-layout wrap>
                <v-flex sm12 md12 lg12 xl12>
                  <v-btn icon flat @click="backlink()">
                    <v-icon>navigate_before</v-icon>
                  </v-btn>
                  <div v-if="data.status=='success'">
                    <v-layout>
                      <h3>แก้ไข BottomMenu</h3>
                      <v-spacer></v-spacer>
                      <div class="edit" @click="stateProcess = 'editBottomMenu'">
                        <v-tooltip bottom>
                          <template v-slot:activator="{ on }">
                            <i class="fas fa-edit" v-on="on"></i>
                          </template>
                          <span>แก้ไข Bottom Menu</span>
                        </v-tooltip>
                      </div>
                      <div class="trash" @click="DeleteBottomMenu()" style="margin-left: 20px;">
                        <v-tooltip bottom>
                          <template v-slot:activator="{ on }">
                            <i class="fas fa-trash-alt" v-on="on"></i>
                          </template>
                          <span>ลบ Bottom Menu</span>
                        </v-tooltip>
                      </div>
                    </v-layout>
                    <div>
                      <v-layout wrap row>
                        <v-flex xs6 sm6 md6 lg6 xl6>
                          <div v-if="data.type_menu==1" class="divTextCenterAll">
                            <v-flex xs12 sm12 md12 lg12 xl12 style="display: flex; padding: 0 !important;justify-content: center;">
                              <div :style="backgroundDiv(data.list_menu[0].picture,'125','125')" class="divTextCenter imageCover">
                                <div class="TextCenterPicture">A</div>
                              </div>
                              <div :style="backgroundDiv(data.list_menu[1].picture,'125','125')" class="divTextCenter imageCover">
                                <div class="TextCenterPicture">B</div>
                              </div>
                              <div :style="backgroundDiv(data.list_menu[2].picture,'125','125')" class="divTextCenter imageCover">
                                <div class="TextCenterPicture">C</div>
                              </div>
                            </v-flex>
                            <v-flex xs12 sm12 md12 lg12 x12 style="display: flex;padding: 0 !important;justify-content: center;">
                              <div :style="backgroundDiv(data.list_menu[3].picture,'125','125')" class="divTextCenter imageCover">
                                <div class="TextCenterPicture">D</div>
                              </div>
                              <div :style="backgroundDiv(data.list_menu[4].picture,'125','125')" class="divTextCenter imageCover">
                                <div class="TextCenterPicture">E</div>
                              </div>
                              <div :style="backgroundDiv(data.list_menu[5].picture,'125','125')" class="divTextCenter imageCover">
                                <div class="TextCenterPicture">F</div>
                              </div>
                            </v-flex>
                            <div class="TextCenterPictureAll">ไม่สามารถแก้ไขได้</div>
                          </div>
                          <div v-else-if="data.type_menu==2" class="divTextCenterAll">
                            <v-flex xs12 sm12 md12 lg12 x12 style="display: flex; padding: 0 !important;justify-content: center;">
                              <div :style="backgroundDiv(data.list_menu[0].picture,'187.5','125')" class="divTextCenter imageCover">
                                <div class="TextCenterPicture">A</div>
                              </div>
                              <div :style="backgroundDiv(data.list_menu[1].picture,'187.5','125')" class="divTextCenter imageCover">
                                <div class="TextCenterPicture">B</div>
                              </div>
                            </v-flex>
                            <v-flex xs12 sm12 md12 lg12 x12 style="display: flex;padding: 0 !important;justify-content: center;">
                              <div :style="backgroundDiv(data.list_menu[2].picture,'187.5','125')" class="divTextCenter imageCover">
                                <div class="TextCenterPicture">C</div>
                              </div>
                              <div :style="backgroundDiv(data.list_menu[3].picture,'187.5','125')" class="divTextCenter imageCover">
                                <div class="TextCenterPicture">D</div>
                              </div>
                            </v-flex>
                            <div class="TextCenterPictureAll">ไม่สามารถแก้ไขได้</div>
                          </div>
                          <div v-else-if="data.type_menu==3" class="divTextCenterAll">
                            <v-flex xs12 sm12 md12 lg12 x12 style="display: flex; padding: 0 !important;justify-content: center;">
                              <div :style="backgroundDiv(data.list_menu[0].picture,'375','125')" class="divTextCenter imageCover">
                                <div class="TextCenterPicture">A</div>
                              </div>
                            </v-flex>
                            <v-flex xs12 sm12 md12 lg12 x12 style="display: flex;padding: 0 !important;justify-content: center;">
                              <div :style="backgroundDiv(data.list_menu[1].picture,'125','125')" class="divTextCenter imageCover">
                                <div class="TextCenterPicture">B</div>
                              </div>
                              <div :style="backgroundDiv(data.list_menu[2].picture,'125','125')" class="divTextCenter imageCover">
                                <div class="TextCenterPicture">C</div>
                              </div>
                              <div :style="backgroundDiv(data.list_menu[3].picture,'125','125')" class="divTextCenter imageCover">
                                <div class="TextCenterPicture">D</div>
                              </div>
                            </v-flex>
                            <div class="TextCenterPictureAll">ไม่สามารถแก้ไขได้</div>
                          </div>
                          <div v-else-if="data.type_menu==4" class="divTextCenterAll">
                            <v-layout wrap>
                              <v-flex style="display: flex; padding: 0 !important;justify-content: flex-end;">
                                <div :style="backgroundDiv(data.list_menu[0].picture,'250','250')" class="divTextCenter imageCover">
                                  <div class="TextCenterPicture">A</div>
                                </div>
                              </v-flex>
                              <v-flex style="display: flex; padding: 0 !important;justify-content: center;">
                                <v-layout wrap style="justify-content: end;">
                                  <v-flex>
                                    <div :style="backgroundDiv(data.list_menu[1].picture,'125','125')" class="divTextCenter imageCover">
                                      <div class="TextCenterPicture">B</div>
                                    </div>
                                    <div :style="backgroundDiv(data.list_menu[2].picture,'125','125')" class="divTextCenter imageCover">
                                      <div class="TextCenterPicture">C</div>
                                    </div>
                                  </v-flex>
                                </v-layout>
                              </v-flex>
                            </v-layout>
                            <div class="TextCenterPictureAll">ไม่สามารถแก้ไขได้</div>
                          </div>
                          <div v-else-if="data.type_menu==5" class="divTextCenterAll">
                            <v-flex xs12 sm12 md12 xl12 style="display: flex; padding: 0 !important;justify-content: center;">
                              <div :style="backgroundDiv(data.list_menu[0].picture,'375','125')" class="divTextCenter imageCover">
                                <div class="TextCenterPicture">A</div>
                              </div>
                            </v-flex>
                            <v-flex style="display: flex; padding: 0 !important;justify-content: center;">
                              <div :style="backgroundDiv(data.list_menu[1].picture,'375','125')" class="divTextCenter imageCover">
                                <div class="TextCenterPicture">B</div>
                              </div>
                            </v-flex>
                            <div class="TextCenterPictureAll">ไม่สามารถแก้ไขได้</div>
                          </div>
                          <div v-else-if="data.type_menu==6" class="divTextCenterAll">
                            <v-flex xs12 sm12 md12 lg12 x12 style="display: flex; padding: 0 !important;justify-content: center;">
                              <div :style="backgroundDiv(data.list_menu[0].picture,'187.5','250')" class="divTextCenter imageCover">
                                <div class="TextCenterPicture">A</div>
                              </div>
                              <div :style="backgroundDiv(data.list_menu[1].picture,'187.5','250')" class="divTextCenter imageCover">
                                <div class="TextCenterPicture">B</div>
                              </div>
                            </v-flex>
                            <div class="TextCenterPictureAll">ไม่สามารถแก้ไขได้</div>
                          </div>
                          <div v-else-if="data.type_menu==7" class="divTextCenterAll">
                            <v-flex s12 sm12 md12 lg12 x12 style="display: flex; padding: 0 !important;justify-content: center;">
                              <div :style="backgroundDiv(data.list_menu[0].picture,'375','250')" class="divTextCenter imageCover">
                                <div class="TextCenterPicture">A</div>
                              </div>
                            </v-flex>
                            <div class="TextCenterPictureAll">ไม่สามารถแก้ไขได้</div>
                          </div>
                          <div v-else-if="data.type_menu==8" class="divTextCenterAll">
                            <v-flex xs12 sm12 md12 lg12 x12 style="display: flex; padding: 0 !important;justify-content: center;">
                              <div :style="backgroundDiv(data.list_menu[0].picture,'125','125')" class="divTextCenter imageCover">
                                <div class="TextCenterPicture">A</div>
                              </div>
                              <div :style="backgroundDiv(data.list_menu[1].picture,'125','125')" class="divTextCenter imageCover">
                                <div class="TextCenterPicture">B</div>
                              </div>
                              <div :style="backgroundDiv(data.list_menu[2].picture,'125','125')" class="divTextCenter imageCover">
                                <div class="TextCenterPicture">C</div>
                              </div>
                            </v-flex>
                            <div class="TextCenterPictureAll">ไม่สามารถแก้ไขได้</div>
                          </div>
                          <div v-else-if="data.type_menu==9" class="divTextCenterAll">
                            <v-flex xs12 sm12 md12 lg12 x12 style="display: flex; padding: 0 !important;justify-content: center;">
                              <div :style="backgroundDiv(data.list_menu[0].picture,'125','125')" class="divTextCenter imageCover">
                                <div class="TextCenterPicture">A</div>
                              </div>
                              <div :style="backgroundDiv(data.list_menu[1].picture,'250','125')" class="divTextCenter imageCover">
                                <div class="TextCenterPicture">B</div>
                              </div>
                            </v-flex>
                            <div class="TextCenterPictureAll">ไม่สามารถแก้ไขได้</div>
                          </div>
                          <div v-else-if="data.type_menu==10" class="divTextCenterAll">
                            <v-flex xs12 sm12 md12 lg12 x12 style="display: flex; padding: 0 !important;justify-content: center;">
                              <div :style="backgroundDiv(data.list_menu[0].picture,'250','125')" class="divTextCenter imageCover">
                                <div class="TextCenterPicture">A</div>
                              </div>
                              <div :style="backgroundDiv(data.list_menu[1].picture,'125','125')" class="divTextCenter imageCover">
                                <div class="TextCenterPicture">B</div>
                              </div>
                            </v-flex>
                            <div class="TextCenterPictureAll">ไม่สามารถแก้ไขได้</div>
                          </div>
                          <div v-else-if="data.type_menu==11" class="divTextCenterAll">
                            <v-flex xs12 sm12 md12 lg12 x12 style="display: flex; padding: 0 !important;justify-content: center;">
                              <div :style="backgroundDiv(data.list_menu[0].picture,'187.5','125')" class="divTextCenter imageCover">
                                <div class="TextCenterPicture">A</div>
                              </div>
                              <div :style="backgroundDiv(data.list_menu[1].picture,'187.5','125')" class="divTextCenter imageCover">
                                <div class="TextCenterPicture">B</div>
                              </div>
                            </v-flex>
                            <div class="TextCenterPictureAll">ไม่สามารถแก้ไขได้</div>
                          </div>
                          <div v-else-if="data.type_menu==12" class="divTextCenterAll">
                            <v-flex xs12 sm12 md12 lg12 x12 style="display: flex; padding: 0 !important;justify-content: center;">
                              <div :style="backgroundDiv(data.list_menu[0].picture,'375','125')" class="divTextCenter imageCover">
                                <div class="TextCenterPicture">A</div>
                              </div>
                            </v-flex>
                            <div class="TextCenterPictureAll">ไม่สามารถแก้ไขได้</div>
                          </div>
                          <div v-else-if="data.type_menu==13">
                            <v-flex xs12 sm12 md12 lg12 x12 style="display: flex; padding: 0 !important;justify-content: center;">
                              <div :style="backgroundDiv(data.list_menu[0].picture,'93.8','93.8')" class="divTextCenter imageCover">
                                <div class="TextCenterPicture">A</div>
                              </div>
                              <div :style="backgroundDiv(data.list_menu[1].picture,'93.8','93.8')" class="divTextCenter imageCover">
                                <div class="TextCenterPicture">B</div>
                              </div>
                              <div :style="backgroundDiv(data.list_menu[2].picture,'93.8','93.8')" class="divTextCenter imageCover">
                                <div class="TextCenterPicture">C</div>
                              </div>
                              <div :style="backgroundDiv(data.list_menu[3].picture,'93.8','93.8')" class="divTextCenter imageCover">
                                <div class="TextCenterPicture">D</div>
                              </div>
                            </v-flex>
                           
                          </div>
                          <v-flex xs12 sm12 md12 lg12 xl12 style="display: flex !important;justify-content: center; padding: 0px;">
                            <div style="height: 45px;width: 375px; background: white; border: 1px solid black;">
                              <v-layout>
                                <v-flex xs2 sm2 md2 xl2 style="padding-top: 10px; padding-bottom:25px;text-align: center;">
                                  <i class="fas fa-keyboard fa-2x" style="padding-right: 4px;"></i>
                                  <v-divider vertical></v-divider>
                                </v-flex>
                                <v-flex xs10 sm10 md10 xl10 style="padding-right:60px;text-align: center;">
                                  <i class="fas fa-caret-down" style="display: inline;"></i>
                                  <p style="padding-top:-2px">{{nameBottom}}</p>
                                </v-flex>
                                <v-divider></v-divider>
                              </v-layout>
                            </div>
                          </v-flex>
                        </v-flex>
                        <v-flex xs6 sm6 md6 lg6 xl6 style="text-align: left;">
                          <v-container style="padding: 0px !important;">
                            <v-flex sm12 md12 lg12 xl12>
                              <v-layout>
                                <strong style="padding-top: 0px;" class="labelAssignMenu">สถานะ : </strong>
                                <v-switch :label="(statusRichMenu==true || statusRichMenu=='true' || statusRichMenu=='1')? 'เปิด':'ปิด'" v-model="statusRichMenu" style="margin-top: 0px !important;"></v-switch>
                              </v-layout>
                              <v-layout row wrap>
                                <strong style="padding-top: 0px;" class="labelAssignMenu">ข้อความ menu : </strong>
                                <v-text-field :counter="14" maxlength="14" :rules="nameBottomRule" v-model="nameBottom" required style="max-width:700px;margin-top: 0px !important; padding-top: 0px !important;"></v-text-field>
                              </v-layout>
                              <v-layout>
                                <strong style="padding-top: 0px;" class="labelAssignMenu">การแสดงเมนูเริ่มต้น :</strong>
                                <v-switch :label="(showBasicMenu==true || showBasicMenu=='true' || showBasicMenu=='1')? 'แสดง':'ซ่อน'" v-model="showBasicMenu" style="margin-top: 0px !important;"></v-switch>
                              </v-layout>
                              <v-btn @click="editBottom()" :disabled="checkDisabledEdit()" class="btnTemplate horizontal_center">บันทึก</v-btn>
                            </v-flex>
                          </v-container>
                        </v-flex>
                      </v-layout>
                    </div>
                    <div style="margin-top:20px;">
                      <v-layout wrap row>
                        <v-flex sm6 md6 lg6 xl6 v-for="(x,i) in data.list_menu " :key="i">
                          <v-layout row wrap class="actionTemplateDetail">
                            <v-flex xs1 sm1 md1 lg1 xl1>
                              <h3>{{A_F[i]}}</h3>
                            </v-flex>
                            <v-flex xs11 sm11 md11 lg11 xl11 style="margin-top: 16px; padding-left: 20px;">
                              <span class="spanStyle">{{checkTypeTH(x['type'])}}
                                <span class="EndpointSize" v-if="x['type']==='webview'">{{x['size']}}</span>
                                <span class="EndpointVerbPost" v-if="x['sign']==='true' && (x['type']==='webview'|| x['type']==='link' || x['type'] === 'link_market' )">onechat_token</span>
                                <span class="EndpointVerbPost" v-if="x['sign_share']==='true'  && (x['type']==='webview'|| x['type']==='link' || x['type'] === 'link_market' )">share token</span>
                                <span class="EndpointVerbPost" v-if="x['location_status']==='true' && x['type'] === 'qrcode'">location</span>
                              </span>
                              <div v-if="x['type']==='link' || x['type'] === 'link_market' || x['type']==='webview'">
                                <p style="color: #757575; margin-top: 10px;">
                                  <read-more class="mb-0" more-str="เพิ่มเติม" :text="x['url']" link="#" less-str="แสดงน้อยลง" :max-chars="80" style="color:#757575;"></read-more>
                                </p>
                              </div>
                              <div v-else-if="x['type']==='text'">
                                <p style="margin-top: 16px; color: #757575;">{{x['message']}}</p>
                              </div>
                              <div v-else-if="x['type']==='location'">
                                <v-layout class="pb-3 pt-2">
                                  <span style="text-align:left; color:red; font-size:12px;">*</span>
                                  &nbsp;
                                  <span style="text-align:left; color:grey; font-size:12px;"> ระบบจะดึงตำแหน่งที่ตั้งปัจจุบันของผู้ใช้งานไปแสดงในห้องแชทเมื่อมีการเรียกใช้งาน Bottom Menu ประเภทโลเคชัน</span>
                                </v-layout>
                              </div>
                              <div v-else-if="x['type']==='qrcode'">
                                <v-layout class="pb-3 pt-3">
                                  <span style="text-align:left; color:red; font-size:12px;">*</span>
                                  &nbsp;
                                  <span style="text-align:left; color:grey; font-size:12px;">ใช้สำหรับการเปิดตัวอ่านคิวอาร์โค้ด</span>
                                </v-layout>
                              </div>
                            </v-flex>
                          </v-layout>
                        </v-flex>
                      </v-layout>
                    </div>
                  </div>
                  <div v-else style="text-align: center;">
                    <h2 style="margin-top:20vh;">ไม่พบข้อมูล BottomMenu ดังกล่าว</h2>
                  </div>
                </v-flex>
              </v-layout>
            </v-container>
          </v-flex>
        </v-layout>
      </v-container>
      <!-- edit -->
      <v-container grid-list-md v-else-if="stateProcess=='editBottomMenu'">
        <v-layout wrap>
          <v-flex sm12 md12 lg12 xl12 style="display: flex; justify-content: center; margin-top: -4vh;">
            <v-container grid-list-md class="mt-2">
              <v-layout wrap>
                <v-flex sm12 md12 lg12 xl12>
                  
                  <v-btn icon flat @click="cancelEdit()">
                    <v-icon>navigate_before</v-icon>
                  </v-btn>
                  <div v-if="data.status=='success'">
                    <v-layout>
                      <h3>แก้ไข BottomMenu</h3>
                      <v-spacer></v-spacer>
                      <div class="trash" @click="DeleteBottomMenu()">
                        <v-tooltip bottom>
                          <template v-slot:activator="{ on }">
                            <i class="fas fa-trash-alt" v-on="on"></i>
                          </template>
                          <span>ลบ Bottom Menu</span>
                        </v-tooltip>
                      </div>
                    </v-layout>
                    <div>
                      <v-layout wrap row>
                        <v-flex xs6 sm6 md6 lg6 xl6>
                          <input ref="fileInput" type="file" @input="onSelectfile" style="display:none">
                          <input ref="fileInput2" type="file" @input="onSelectfile2" style="display:none">
                          <input ref="fileInput3" type="file" @input="onSelectfile3" style="display:none">
                          <input ref="fileInput4" type="file" @input="onSelectfile4" style="display:none">
                          <input ref="fileInput5" type="file" @input="onSelectfile5" style="display:none">
                          <input ref="fileInput6" type="file" @input="onSelectfile6" style="display:none">
                          <div v-if="data.type_menu==1">
                            <v-flex xs12 sm12 md12 lg12 xl12 style="display: flex; padding: 0 !important;justify-content: center;">
                              <div style="height: 125px;width: 125px;  border: 1px solid black; cursor:pointer" @click="chooseImage" class="divTextCenter">
                                <v-img v-if="url" :src="url" aspect-ratio="1" cover />
                                <div class="TextCenterPicture">A</div>
                              </div>
                              <div style="height: 125px;width: 125px;background: #f0f0f0; border: 1px solid black;  cursor:pointer;" @click="chooseImage2" class="divTextCenter">
                                <v-img v-if="url2" :src="url2" aspect-ratio="1" cover />
                                <div class="TextCenterPicture">B</div>
                              </div>
                              <div style="height: 125px;width: 125px;background: #f0f0f0; border: 1px solid black; cursor:pointer;" @click="chooseImage3" class="divTextCenter">
                                <v-img v-if="url3" :src="url3" aspect-ratio="1" cover />
                                <div class="TextCenterPicture">C</div>
                              </div>
                            </v-flex>
                            <v-flex xs12 sm12 md12 lg12 x12 style="display: flex;padding: 0 !important;justify-content: center;">
                              <div style="height: 125px;width: 125px; background: #f0f0f0; border: 1px solid black;cursor:pointer;" @click="chooseImage4" class="divTextCenter">
                                <v-img v-if="url4" :src="url4" aspect-ratio="1" cover />
                                <div class="TextCenterPicture">D</div>
                              </div>
                              <div style="height: 125px;width: 125px;background: #f0f0f0; border: 1px solid black;  cursor:pointer;" @click="chooseImage5" class="divTextCenter">
                                <v-img v-if="url5" :src="url5" aspect-ratio="1" cover />
                                <div class="TextCenterPicture">E</div>
                              </div>
                              <div style="height: 125px;width: 125px;background: #f0f0f0; border: 1px solid black;  cursor:pointer;" @click="chooseImage6" class="divTextCenter">
                                <v-img v-if="url6" :src="url6" aspect-ratio="1" cover />
                                <div class="TextCenterPicture">F</div>
                              </div>
                            </v-flex>
                          </div>
                          <div v-else-if="data.type_menu==2">
                            <v-flex xs12 sm12 md12 lg12 x12 style="display: flex; padding: 0 !important;justify-content: center;">
                              <div style="height: 125px;width: 187.5px; background: #f0f0f0; border: 1px solid black;cursor:pointer;" @click="chooseImage" class="divTextCenter">
                                <v-img v-if="url" :src="url" max-height="125" aspect-ratio="1" cover />
                                <div class="TextCenterPicture">A</div>
                              </div>
                              <div style="height: 125px;width: 187.5px; background: #f0f0f0; border: 1px solid black;cursor:pointer;" @click="chooseImage2" class="divTextCenter">
                                <v-img v-if="url2" :src="url2" max-height="125" aspect-ratio="1" cover />
                                <div class="TextCenterPicture">B</div>
                              </div>
                            </v-flex>
                            <v-flex xs12 sm12 md12 lg12 x12 style="display: flex;padding: 0 !important;justify-content: center;">
                              <div style="height: 125px;width: 187.5px; background: #f0f0f0; border: 1px solid black;cursor:pointer;" @click="chooseImage3" class="divTextCenter">
                                <v-img v-if="url3" :src="url3" max-height="125" aspect-ratio="1" cover />
                                <div class="TextCenterPicture">C</div>
                              </div>
                              <div style="height: 125px;width: 187.5px; background: #f0f0f0; border: 1px solid black;cursor:pointer;" @click="chooseImage4" class="divTextCenter">
                                <v-img v-if="url4" :src="url4" max-height="125" aspect-ratio="1" cover />
                                <div class="TextCenterPicture">D</div>
                              </div>
                            </v-flex>
                          </div>
                          <div v-else-if="data.type_menu==3">
                            <v-flex xs12 sm12 md12 lg12 x12 style="display: flex; padding: 0 !important;justify-content: center;">
                              <div style="height: 125px;width: 375px; background: #f0f0f0; border: 1px solid black;cursor:pointer;" @click="chooseImage" class="divTextCenter">
                                <v-img v-if="url" :src="url" max-height="125" aspect-ratio="1" cover />
                                <div class="TextCenterPicture">A</div>
                              </div>
                            </v-flex>
                            <v-flex xs12 sm12 md12 lg12 x12 style="display: flex;padding: 0 !important;justify-content: center;">
                              <div style="height: 125px;width: 125px; background: #f0f0f0; border: 1px solid black;cursor:pointer;" @click="chooseImage2" class="divTextCenter">
                                <v-img v-if="url2" :src="url2" max-height="125" aspect-ratio="1" cover />
                                <div class="TextCenterPicture">B</div>
                              </div>
                              <div style="height: 125px;width: 125px; background: #f0f0f0; border: 1px solid black;cursor:pointer;" @click="chooseImage3" class="divTextCenter">
                                <v-img v-if="url3" :src="url3" max-height="125" aspect-ratio="1" cover />
                                <div class="TextCenterPicture">C</div>
                              </div>
                              <div style="height: 125px;width: 125px; background: #f0f0f0; border: 1px solid black;cursor:pointer;" @click="chooseImage4" class="divTextCenter">
                                <v-img v-if="url4" :src="url4" max-height="125" aspect-ratio="1" cover />
                                <div class="TextCenterPicture">D</div>
                              </div>
                            </v-flex>
                          </div>
                          <div v-else-if="data.type_menu==4">
                            <v-layout wrap>
                              <v-flex style="display: flex; padding: 0 !important;justify-content: flex-end;">
                                <div style="height: 250px; width: 250px; background: #f0f0f0; border: 1px solid black; cursor:pointer;" @click="chooseImage" class="divTextCenter">
                                  <v-img v-if="url" :src="url" max-height="250" aspect-ratio="1" cover />
                                  <div class="TextCenterPicture">A</div>
                                </div>
                              </v-flex>
                              <v-flex style="display: flex; padding: 0 !important;justify-content: center;">
                                <v-layout wrap style="justify-content: end;">
                                  <v-flex>
                                    <div style="height: 125px; width: 125px; background: #f0f0f0; border: 1px solid black; cursor:pointer;" @click="chooseImage2" class="divTextCenter">
                                      <v-img v-if="url2" :src="url2" max-height="125" aspect-ratio="1" cover />
                                      <div class="TextCenterPicture">B</div>
                                    </div>
                                    <div style="height: 125px; width: 125px; background: #f0f0f0; border: 1px solid black; cursor:pointer;" @click="chooseImage3" class="divTextCenter">
                                      <v-img v-if="url3" :src="url3" max-height="125" aspect-ratio="1" cover />
                                      <div class="TextCenterPicture">C</div>
                                    </div>
                                  </v-flex>
                                </v-layout>
                              </v-flex>
                            </v-layout>
                          </div>
                          <div v-else-if="data.type_menu==5">
                            <v-flex xs12 sm12 md12 xl12 style="display: flex; padding: 0 !important;justify-content: center;">
                              <div style="height: 125px; width: 375px; background: #f0f0f0; border: 1px solid black;cursor:pointer;" @click="chooseImage" class="divTextCenter">
                                <v-img v-if="url" :src="url" max-height="125" min-width="375" aspect-ratio="1" cover />
                                <div class="TextCenterPicture">A</div>
                              </div>
                            </v-flex>
                            <v-flex style="display: flex; padding: 0 !important;justify-content: center;">
                              <div style="height: 125px;width: 375px; background: #f0f0f0; border: 1px solid black; cursor:pointer;" @click="chooseImage2" class="divTextCenter">
                                <v-img v-if="url2" :src="url2" max-height="125" min-width="375" aspect-ratio="2" cover />
                                <div class="TextCenterPicture">B</div>
                              </div>
                            </v-flex>
                          </div>
                          <div v-else-if="data.type_menu==6">
                            <v-flex xs12 sm12 md12 lg12 x12 style="display: flex; padding: 0 !important;justify-content: center;">
                              <div style="height: 250px;width: 187.5px; background: #f0f0f0; border: 1px solid black;cursor:pointer;" @click="chooseImage" class="divTextCenter">
                                <v-img v-if="url" :src="url" max-height="250" min-width="187.5" min-height="250" aspect-ratio="1" cover />
                                <div class="TextCenterPicture">A</div>
                              </div>
                              <div style="height: 250px;width: 187.5px; background: #f0f0f0; border: 1px solid black; cursor:pointer;" @click="chooseImage2" class="divTextCenter">
                                <v-img v-if="url2" :src="url2" max-height="250" min-width="187.5" min-height="250" aspect-ratio="1" cover />
                                <div class="TextCenterPicture">B</div>
                              </div>
                            </v-flex>
                          </div>
                          <div v-else-if="data.type_menu==7">
                            <v-flex s12 sm12 md12 lg12 x12 style="display: flex; padding: 0 !important;justify-content: center;">
                              <div style="height: 250px;width:375px; background: #f0f0f0; border: 1px solid black;cursor:pointer;" @click="chooseImage" class="divTextCenter">
                                <v-img v-if="url" :src="url" max-height="250" aspect-ratio="1" cover />
                                <div class="TextCenterPicture">A</div>
                              </div>
                            </v-flex>
                          </div>
                          <div v-else-if="data.type_menu==8">
                            <v-flex xs12 sm12 md12 lg12 x12 style="display: flex; padding: 0 !important;justify-content: center;">
                              <div style="height: 125px;width:125px; background: #f0f0f0; border: 1px solid black;cursor:pointer;" @click="chooseImage" class="divTextCenter">
                                <v-img v-if="url" :src="url" aspect-ratio="1" cover />
                                <div class="TextCenterPicture">A</div>
                              </div>
                              <div style="height: 125px;width:125px; background: #f0f0f0; border: 1px solid black;cursor:pointer;" @click="chooseImage2" class="divTextCenter">
                                <v-img v-if="url2" :src="url2" aspect-ratio="1" cover />
                                <div class="TextCenterPicture">B</div>
                              </div>
                              <div style="height: 125px;width:125px; background: #f0f0f0; border: 1px solid black;cursor:pointer;" @click="chooseImage3" class="divTextCenter">
                                <v-img v-if="url3" :src="url3" aspect-ratio="1" cover />
                                <div class="TextCenterPicture">C</div>
                              </div>
                            </v-flex>
                          </div>
                          <div v-else-if="data.type_menu==9">
                            <v-flex xs12 sm12 md12 lg12 x12 style="display: flex; padding: 0 !important;justify-content: center;">
                              <div style="height: 125px;width:125px; background: #f0f0f0; border: 1px solid black;cursor:pointer;" @click="chooseImage" class="divTextCenter">
                                <v-img v-if="url" :src="url" aspect-ratio="1" cover />
                                <div class="TextCenterPicture">A</div>
                              </div>
                              <div style="height: 125px;width:250px; background: #f0f0f0; border: 1px solid black;cursor:pointer;" @click="chooseImage2" class="divTextCenter">
                                <v-img v-if="url2" :src="url2" max-width="250" max-height="125" aspect-ratio="1" cover />
                                <div class="TextCenterPicture">B</div>
                              </div>
                            </v-flex>
                          </div>
                          <div v-else-if="data.type_menu==10">
                            <v-flex xs12 sm12 md12 lg12 x12 style="display: flex; padding: 0 !important;justify-content: center;">
                              <div style="height: 125px;width:250px; background: #f0f0f0; border: 1px solid black;cursor:pointer;" @click="chooseImage" class="divTextCenter">
                                <v-img v-if="url" :src="url" max-width="250" max-height="125" aspect-ratio="1" cover />
                                <div class="TextCenterPicture">A</div>
                              </div>
                              <div style="height: 125px;width:125px; background: #f0f0f0; border: 1px solid black;cursor:pointer;" @click="chooseImage2" class="divTextCenter">
                                <v-img v-if="url2" :src="url2" aspect-ratio="1" cover />
                                <div class="TextCenterPicture">B</div>
                              </div>
                            </v-flex>
                          </div>
                          <div v-else-if="data.type_menu==11">
                            <v-flex xs12 sm12 md12 lg12 x12 style="display: flex; padding: 0 !important;justify-content: center;">
                              <div style="height: 125px;width:187.5px; background: #f0f0f0; border: 1px solid black;cursor:pointer;" @click="chooseImage" class="divTextCenter">
                                <v-img v-if="url" :src="url" max-width="187.5" max-height="125" aspect-ratio="1" cover />
                                <div class="TextCenterPicture">A</div>
                              </div>
                              <div style="height: 125px;width:187.5px; background: #f0f0f0; border: 1px solid black;cursor:pointer;" @click="chooseImage2" class="divTextCenter">
                                <v-img v-if="url2" :src="url2" max-width="187.5" max-height="125" aspect-ratio="1" cover />
                                <div class="TextCenterPicture">B</div>
                              </div>
                            </v-flex>
                          </div>
                          <div v-else-if="data.type_menu==12">
                            <v-flex xs12 sm12 md12 lg12 x12 style="display: flex; padding: 0 !important;justify-content: center;">
                              <div style="height: 125px;width:375px; background: #f0f0f0; border: 1px solid black;cursor:pointer;" @click="chooseImage" class="divTextCenter">
                                <v-img v-if="url" :src="url" max-width="375" max-height="125" aspect-ratio="1" cover />
                                <div class="TextCenterPicture">A</div>
                              </div>
                            </v-flex>
                          </div>
                          <div v-else-if="data.type_menu==13">
                            <v-flex xs12 sm12 md12 lg12 x12 style="display: flex; padding: 0 !important;justify-content: center;">
                              <div style="height: 93.8px;width:93.8px; background: #f0f0f0; border: 1px solid black;cursor:pointer;" @click="chooseImage" class="divTextCenter">
                                <v-img v-if="url" :src="url" max-height="282" max-width="282" aspect-ratio="1" cover />
                                <div class="TextCenterPicture">A</div>
                              </div>
                              <div style="height: 93.8px;width:93.8px; background: #f0f0f0; border: 1px solid black;cursor:pointer;" @click="chooseImage2" class="divTextCenter">
                                <v-img v-if="url2" :src="url2" max-height="282" max-width="282" aspect-ratio="1" cover />
                                <div class="TextCenterPicture">B</div>
                              </div>
                              <div style="height: 93.8px;width:93.8px; background: #f0f0f0; border: 1px solid black;cursor:pointer;" @click="chooseImage3" class="divTextCenter">
                                <v-img v-if="url3" :src="url3" max-height="282" max-width="282" aspect-ratio="1" cover />
                                <div class="TextCenterPicture">C</div>
                              </div>
                              <div style="height: 93.8px;width:93.8px; background: #f0f0f0; border: 1px solid black;cursor:pointer;" @click="chooseImage4" class="divTextCenter">
                                <v-img v-if="url4" :src="url4" max-height="282" max-width="282" aspect-ratio="1" cover />
                                <div class="TextCenterPicture">D</div>
                              </div>
                            </v-flex>
                          </div>
                          <v-flex xs12 sm12 md12 lg12 xl12 style="display: flex !important;justify-content: center; padding: 0px;">
                            <div style="height: 45px;width: 375px; background: white; border: 1px solid black;">
                              <v-layout>
                                <v-flex xs2 sm2 md2 xl2 style="padding-top: 10px; padding-bottom:25px;text-align: center;">
                                  <i class="fas fa-keyboard fa-2x" style="padding-right: 4px;"></i>
                                  <v-divider vertical></v-divider>
                                </v-flex>
                                <v-flex xs10 sm10 md10 xl10 style="padding-right:60px;text-align: center;">
                                  <i class="fas fa-caret-down" style="display: inline;"></i>
                                  <p style="padding-top:-2px">{{nameBottom}}</p>
                                </v-flex>
                                <v-divider></v-divider>
                              </v-layout>
                            </div>
                          </v-flex>
                          <v-container style="padding: 15px !important;">
                            <v-flex sm12 md12 lg12 xl12 style="border: 1px solid rgb(99, 99, 99); border-radius: 10px;padding: 10px">
                              <v-layout>
                                <strong style="padding-top: 0px;" class="labelAssignMenu">สถานะ : </strong>
                                <v-switch :label="(statusRichMenu==true || statusRichMenu=='true' || statusRichMenu=='1')? 'เปิด':'ปิด'" v-model="statusRichMenu" style="margin-top: 0px !important;"></v-switch>
                              </v-layout>
                              <v-layout row wrap>
                                <strong style="padding-top: 0px;" class="labelAssignMenu">ข้อความ menu : </strong>
                                <v-text-field :counter="14" maxlength="14" :rules="nameBottomRule" v-model="nameBottom" required style="max-width:700px;margin-top: 0px !important; padding-top: 0px !important;"></v-text-field>
                              </v-layout>
                              <v-layout>
                                <strong style="padding-top: 0px;    padding-bottom: 0px;" class="labelAssignMenu">การแสดงเมนูเริ่มต้น :</strong>
                                <v-switch :label="(showBasicMenu==true || showBasicMenu=='true' || showBasicMenu=='1')? 'แสดง':'ซ่อน'" v-model="showBasicMenu" style="margin-top: 0px !important;"></v-switch>
                              </v-layout>
                            </v-flex>
                          </v-container>
                          <div style="display: flex; margin-top: 10px;">
                            <v-btn @click="cancelEdit()" class="btnTemplate horizontal_center" style="background: #da3a49 !important;">ยกเลิก</v-btn>
                            <v-btn @click="editBottomMenu()" :disabled="disabledBtnCreate()" class="btnTemplate horizontal_center">บันทึก</v-btn>
                          </div>
                        </v-flex>
                        <v-flex xs6 sm6 md6 lg6 xl6 style="text-align: left;height: 70vh; overflow-y: scroll;border: 1px solid #646464; border-radius: 10px;">
                          <!-- A -->
                          <v-layout row wrap class="actionTemplateDetailEdit" style="padding-bottom: 10px !important;">
                            <v-flex xs2 sm2 md2 lg2 x2>
                              <h3>A</h3>
                            </v-flex>
                            <v-flex xs9 sm9 md9 lg9 x9>
                              <v-select :items="type_menu" v-model="type" style="margin: 0 !important;padding: 0 !important;" @change="clearCardDetail()"></v-select>
                              <div v-if="type==='link' || type === 'link_market'">
                                <v-text-field single-line v-model="urlLink" label="URL" style="padding-top: 0px !important;"></v-text-field>
                                <v-layout v-if="type === 'link'" style=" margin-top: 5px;">
                                  <span style="margin-top:10px;">ข้อมูลผู้ใช้ :</span>
                                  <!-- <i class="fas fa-info-circle iconSizeWebview" @click="dialoggetProfile = true"></i> -->
                                  <v-radio-group v-model="profile" row style="margin-top: 5px !important;">
                                    <v-radio label="ต้องการ" value="true"></v-radio>
                                    <v-radio label="ไม่ต้องการ" value="false"></v-radio>
                                  </v-radio-group>
                                </v-layout>
                                <v-layout v-if="profile === 'true' && type === 'link'" class="typeProfile" style=" margin-top: 5px;">
                                  <span style="margin-top:10px; margin-right:10px;width: max-content;">ประเภทข้อมูล :</span>
                                  <v-radio-group hide-details v-model="signtype" row style="width: min-content;">
                                    <v-radio value="sign_share" label="share token"></v-radio>
                                    <i class="fas fa-info-circle iconTypeWebview" @click="dialogShareToken= true"></i>
                                    <v-radio value="sign" label="onechat_token"></v-radio>
                                    <i class="fas fa-info-circle iconTypeWebview" @click="dialoggetProfile = true"></i>
                                  </v-radio-group>
                                </v-layout>
                              </div>
                              <div v-else-if="type==='webview'">
                                <v-text-field single-line v-model="urlLink" label="URL" style="padding-top: 0px !important;"></v-text-field>
                                <v-layout style=" margin-top: 5px;">
                                  <span style="margin-top:10px;">ข้อมูลผู้ใช้ :</span>
                                  <!-- <i class="fas fa-info-circle iconSizeWebview" @click="dialoggetProfile = true"></i> -->
                                  <v-radio-group v-model="profile" row style="margin-top: 0px !important;">
                                    <v-radio label="ต้องการ" value="true"></v-radio>
                                    <v-radio label="ไม่ต้องการ" value="false"></v-radio>
                                  </v-radio-group>
                                </v-layout>
                                <v-layout v-if="profile === 'true'" class="typeProfile" style=" margin-top: 5px;">
                                  <span style="margin-top:10px; margin-right:10px;width: max-content;">ประเภทข้อมูล :</span>
                                  <v-radio-group v-model="signtype" row hide-details style="width: min-content;">
                                    <v-radio value="sign_share" label="share token"></v-radio>
                                    <i class="fas fa-info-circle iconTypeWebview" @click="dialogShareToken = true"></i>
                                    <v-radio value="sign" label="onechat_token"></v-radio>
                                    <i class="fas fa-info-circle iconTypeWebview" @click="dialoggetProfile = true"></i>
                                  </v-radio-group>
                                </v-layout>
                                <v-layout style=" margin-top: 5px;">
                                  <span style="margin-top:10px; margin-right:10px;width: max-content;">ขนาด :</span>
                                  <i class="fas fa-info-circle iconSizeWebview" @click="dialogSizeWebviewExample = true"></i>
                                  <v-radio-group v-model="showSize" row style="margin-top: 5px !important;width: min-content;">
                                    <v-radio label="Compact" value="compact"></v-radio>
                                    <v-radio label="Tall" value="tall"></v-radio>
                                    <v-radio label="Full" value="full"></v-radio>
                                  </v-radio-group>
                                </v-layout>
                              </div>
                              <div v-else-if="type==='text'">
                                <v-text-field single-line v-model="text" :counter="50" maxlength="50" label="ข้อความ" style="padding-top: 0px !important;margin-bottom: 10px;"></v-text-field>
                              </div>
                              <div v-else-if="type==='location'">
                                <v-layout class="pb-2 pt-2">
                                  <span style="text-align:left; color:red; font-size:12px;">*</span>
                                  &nbsp;
                                  <span style="text-align:left; color:grey; font-size:12px;"> ระบบจะดึงตำแหน่งที่ตั้งปัจจุบันของผู้ใช้งานไปแสดงในห้องแชทเมื่อมีการเรียกใช้งาน Bottom Menu ประเภทโลเคชัน</span>
                                </v-layout>
                              </div>
                              <div v-else-if="type==='qrcode'">
                                <v-layout>
                                  <span style="margin-top:10px; margin-right:10px">ต้องการโลเคชัน :</span>
                                  <v-radio-group hide-details v-model="location" row style="margin-top: 5px !important;">
                                    <v-radio label="ต้องการ" value="true"></v-radio>
                                    <v-radio label="ไม่ต้องการ" value="false"></v-radio>
                                  </v-radio-group>
                                </v-layout>
                                <v-layout class="pb-3 pt-3">
                                  <span style="text-align:left; color:red; font-size:12px;">*</span>
                                  &nbsp;
                                  <span style="text-align:left; color:grey; font-size:12px;">ใช้สำหรับการเปิดตัวอ่านคิวอาร์โค้ด</span>
                                </v-layout>
                              </div>
                            </v-flex>
                          </v-layout>
                          <!-- B -->
                          <v-layout row wrap class="actionTemplateDetailEdit" style="padding-bottom: 10px !important;" v-if="templateDetail[template-1] >= 2">
                            <v-flex xs2 sm2 md2 lg2 x2>
                              <h3>B</h3>
                            </v-flex>
                            <v-flex xs9 sm9 md9 lg9 x9>
                              <v-select :items="type_menu" v-model="type2" style="margin: 0 !important;padding: 0 !important;" @change="clearCardDetail(2)"></v-select>
                              <div v-if="type2==='link' || type2 === 'link_market'">
                                <v-text-field single-line v-model="urlLink2" label="URL" style="padding-top: 0px !important;"></v-text-field>
                                <v-layout v-if="type2 === 'link'" style=" margin-top: 5px;">
                                  <span style="margin-top:10px;">ข้อมูลผู้ใช้ :</span>
                                  <!-- <i class="fas fa-info-circle iconSizeWebview" @click="dialoggetProfile = true"></i> -->
                                  <v-radio-group v-model="profile2" row style="margin-top: 5px !important;">
                                    <v-radio label="ต้องการ" value="true"></v-radio>
                                    <v-radio label="ไม่ต้องการ" value="false"></v-radio>
                                  </v-radio-group>
                                </v-layout>
                                <v-layout v-if="profile2 === 'true' && type2 === 'link'" class="typeProfile" style=" margin-top: 5px;">
                                  <span style="margin-top:10px; margin-right:10px;width: max-content;">ประเภทข้อมูล :</span>
                                  <v-radio-group hide-details v-model="signtype2" row style="width: min-content;">
                                    <v-radio value="sign_share" label="share token"></v-radio>
                                    <i class="fas fa-info-circle iconTypeWebview" @click="dialogShareToken= true"></i>
                                    <v-radio value="sign" label="onechat_token"></v-radio>
                                    <i class="fas fa-info-circle iconTypeWebview" @click="dialoggetProfile = true"></i>
                                  </v-radio-group>
                                </v-layout>
                              </div>
                              <div v-else-if="type2 ==='webview'">
                                <v-text-field single-line v-model="urlLink2" label="URL" style="padding-top: 0px !important;"></v-text-field>
                                <v-layout style=" margin-top: 5px;">
                                  <span style="margin-top:10px;">ข้อมูลผู้ใช้ :</span>
                                  <!-- <i class="fas fa-info-circle iconSizeWebview" @click="dialoggetProfile = true"></i> -->
                                  <v-radio-group v-model="profile2" row style="margin-top: 0px !important;">
                                    <v-radio label="ต้องการ" value="true"></v-radio>
                                    <v-radio label="ไม่ต้องการ" value="false"></v-radio>
                                  </v-radio-group>
                                </v-layout>
                                <v-layout v-if="profile2 === 'true'" class="typeProfile" style=" margin-top: 5px;">
                                  <span style="margin-top:10px; margin-right:10px;width: max-content;">ประเภทข้อมูล :</span>
                                  <v-radio-group v-model="signtype2" row hide-details style="width: min-content;">
                                    <v-radio value="sign_share" label="share token"></v-radio>
                                    <i class="fas fa-info-circle iconTypeWebview" @click="dialogShareToken = true"></i>
                                    <v-radio value="sign" label="onechat_token"></v-radio>
                                    <i class="fas fa-info-circle iconTypeWebview" @click="dialoggetProfile = true"></i>
                                  </v-radio-group>
                                </v-layout>
                                <v-layout style=" margin-top: 5px;">
                                  <span style="margin-top:10px; margin-right:10px;width: max-content;">ขนาด :</span>
                                  <i class="fas fa-info-circle iconSizeWebview" @click="dialogSizeWebviewExample = true"></i>
                                  <v-radio-group v-model="showSize2" row style="margin-top: 5px !important;width: min-content;">
                                    <v-radio label="Compact" value="compact"></v-radio>
                                    <v-radio label="Tall" value="tall"></v-radio>
                                    <v-radio label="Full" value="full"></v-radio>
                                  </v-radio-group>
                                </v-layout>
                              </div>
                              <div v-else-if="type2==='text'">
                                <v-text-field single-line v-model="text2" :counter="50" maxlength="50" label="ข้อความ" style="padding-top: 0px !important;margin-bottom: 10px;"></v-text-field>
                              </div>
                              <div v-else-if="type2==='location'">
                                <v-layout class="pb-2 pt-2">
                                  <span style="text-align:left; color:red; font-size:12px;">*</span>
                                  &nbsp;
                                  <span style="text-align:left; color:grey; font-size:12px;"> ระบบจะดึงตำแหน่งที่ตั้งปัจจุบันของผู้ใช้งานไปแสดงในห้องแชทเมื่อมีการเรียกใช้งาน Bottom Menu ประเภทโลเคชัน</span>
                                </v-layout>
                              </div>
                              <div v-else-if="type2==='qrcode'">
                                <v-layout>
                                  <span style="margin-top:10px; margin-right:10px">ต้องการโลเคชัน :</span>
                                  <v-radio-group hide-details v-model="location2" row style="margin-top: 5px !important;">
                                    <v-radio label="ต้องการ" value="true"></v-radio>
                                    <v-radio label="ไม่ต้องการ" value="false"></v-radio>
                                  </v-radio-group>
                                </v-layout>
                                <v-layout class="pb-3 pt-3">
                                  <span style="text-align:left; color:red; font-size:12px;">*</span>
                                  &nbsp;
                                  <span style="text-align:left; color:grey; font-size:12px;"> ใช้สำหรับการเปิดตัวอ่านคิวอาร์โค้ด</span>
                                </v-layout>
                              </div>
                            </v-flex>
                          </v-layout>
                          <!-- C -->
                          <v-layout row wrap class="actionTemplateDetailEdit" style="padding-bottom: 10px !important;" v-if="templateDetail[template-1] >= 3">
                            <v-flex xs2 sm2 md2 lg2 x2>
                              <h3>C</h3>
                            </v-flex>
                            <v-flex xs9 sm9 md9 lg9 x9>
                              <v-select :items="type_menu" v-model="type3" style="margin: 0 !important;padding: 0 !important;" @change="clearCardDetail(3)"></v-select>
                              <div v-if="type3==='link' || type3 === 'link_market'">
                                <v-text-field single-line v-model="urlLink3" label="URL" style="padding-top: 0px !important;"></v-text-field>
                                <v-layout v-if="type3 === 'link'" style=" margin-top: 5px;">
                                  <span style="margin-top:10px;">ข้อมูลผู้ใช้ :</span>
                                  <!-- <i class="fas fa-info-circle iconSizeWebview" @click="dialoggetProfile = true"></i> -->
                                  <v-radio-group v-model="profile3" row style="margin-top: 5px !important;">
                                    <v-radio label="ต้องการ" value="true"></v-radio>
                                    <v-radio label="ไม่ต้องการ" value="false"></v-radio>
                                  </v-radio-group>
                                </v-layout>
                                <v-layout v-if="profile3 === 'true' && type3 === 'link'" class="typeProfile" style=" margin-top: 5px;">
                                  <span style="margin-top:10px; margin-right:10px;width: max-content;">ประเภทข้อมูล :</span>
                                  <v-radio-group hide-details v-model="signtype3" row style="width: min-content;">
                                    <v-radio value="sign_share" label="share token"></v-radio>
                                    <i class="fas fa-info-circle iconTypeWebview" @click="dialogShareToken= true"></i>
                                    <v-radio value="sign" label="onechat_token"></v-radio>
                                    <i class="fas fa-info-circle iconTypeWebview" @click="dialoggetProfile = true"></i>
                                  </v-radio-group>
                                </v-layout>
                              </div>
                              <div v-else-if="type3 ==='webview'">
                                <v-text-field single-line v-model="urlLink3" label="URL" style="padding-top: 0px !important;"></v-text-field>
                                <v-layout style=" margin-top: 5px;">
                                  <span style="margin-top:10px;">ข้อมูลผู้ใช้ :</span>
                                  <!-- <i class="fas fa-info-circle iconSizeWebview" @click="dialoggetProfile = true"></i> -->
                                  <v-radio-group v-model="profile3" row style="margin-top: 0px !important;">
                                    <v-radio label="ต้องการ" value="true"></v-radio>
                                    <v-radio label="ไม่ต้องการ" value="false"></v-radio>
                                  </v-radio-group>
                                </v-layout>
                                <v-layout v-if="profile3 === 'true'" class="typeProfile" style=" margin-top: 5px;">
                                  <span style="margin-top:10px; margin-right:10px;width: max-content;">ประเภทข้อมูล :</span>
                                  <v-radio-group v-model="signtype3" row hide-details style="width: min-content;">
                                    <v-radio value="sign_share" label="share token"></v-radio>
                                    <i class="fas fa-info-circle iconTypeWebview" @click="dialogShareToken = true"></i>
                                    <v-radio value="sign" label="onechat_token"></v-radio>
                                    <i class="fas fa-info-circle iconTypeWebview" @click="dialoggetProfile = true"></i>
                                  </v-radio-group>
                                </v-layout>
                                <v-layout style=" margin-top: 5px;">
                                  <span style="margin-top:10px; margin-right:10px;width: max-content;">ขนาด :</span>
                                  <i class="fas fa-info-circle iconSizeWebview" @click="dialogSizeWebviewExample = true"></i>
                                  <v-radio-group v-model="showSize3" row style="margin-top: 5px !important;width: min-content;">
                                    <v-radio label="Compact" value="compact"></v-radio>
                                    <v-radio label="Tall" value="tall"></v-radio>
                                    <v-radio label="Full" value="full"></v-radio>
                                  </v-radio-group>
                                </v-layout>
                              </div>
                              <div v-else-if="type3==='text'">
                                <v-text-field single-line v-model="text3" :counter="50" maxlength="50" label="ข้อความ" style="padding-top: 0px !important;margin-bottom: 10px;"></v-text-field>
                              </div>
                              <div v-else-if="type3==='location'">
                                <v-layout class="pb-2 pt-2">
                                  <span style="text-align:left; color:red; font-size:12px;">*</span>
                                  &nbsp;
                                  <span style="text-align:left; color:grey; font-size:12px;"> ระบบจะดึงตำแหน่งที่ตั้งปัจจุบันของผู้ใช้งานไปแสดงในห้องแชทเมื่อมีการเรียกใช้งาน Bottom Menu ประเภทโลเคชัน</span>
                                </v-layout>
                              </div>
                              <div v-else-if="type3==='qrcode'">
                                <v-layout>
                                  <span style="margin-top:10px; margin-right:10px">ต้องการโลเคชัน :</span>
                                  <v-radio-group hide-details v-model="location3" row style="margin-top: 5px !important;">
                                    <v-radio label="ต้องการ" value="true"></v-radio>
                                    <v-radio label="ไม่ต้องการ" value="false"></v-radio>
                                  </v-radio-group>
                                </v-layout>
                                <v-layout class="pb-3 pt-3">
                                  <span style="text-align:left; color:red; font-size:12px;">*</span>
                                  &nbsp;
                                  <span style="text-align:left; color:grey; font-size:12px;"> ใช้สำหรับการเปิดตัวอ่านคิวอาร์โค้ด</span>
                                </v-layout>
                              </div>
                            </v-flex>
                          </v-layout>
                          <!-- D -->
                          <v-layout row wrap class="actionTemplateDetailEdit" style="padding-bottom: 10px !important;" v-if="templateDetail[template-1] >= 4">
                            <v-flex xs2 sm2 md2 lg2 x2>
                              <h3>D</h3>
                            </v-flex>
                            <v-flex xs9 sm9 md9 lg9 x9>
                              <v-select :items="type_menu" v-model="type4" style="margin: 0 !important;padding: 0 !important;" @change="clearCardDetail(4)"></v-select>
                              <div v-if="type4==='link' || type4 === 'link_market'">
                                <v-text-field single-line v-model="urlLink4" label="URL" style="padding-top: 0px !important;"></v-text-field>
                                <v-layout v-if="type4 === 'link'" style=" margin-top: 5px;">
                                  <span style="margin-top:10px;">ข้อมูลผู้ใช้ :</span>
                                  <!-- <i class="fas fa-info-circle iconSizeWebview" @click="dialoggetProfile = true"></i> -->
                                  <v-radio-group v-model="profile4" row style="margin-top: 5px !important;">
                                    <v-radio label="ต้องการ" value="true"></v-radio>
                                    <v-radio label="ไม่ต้องการ" value="false"></v-radio>
                                  </v-radio-group>
                                </v-layout>
                                <v-layout v-if="profile4 === 'true' && type4 === 'link'" class="typeProfile" style=" margin-top: 5px;">
                                  <span style="margin-top:10px; margin-right:10px;width: max-content;">ประเภทข้อมูล :</span>
                                  <v-radio-group hide-details v-model="signtype4" row style="width: min-content;">
                                    <v-radio value="sign_share" label="share token"></v-radio>
                                    <i class="fas fa-info-circle iconTypeWebview" @click="dialogShareToken= true"></i>
                                    <v-radio value="sign" label="onechat_token"></v-radio>
                                    <i class="fas fa-info-circle iconTypeWebview" @click="dialoggetProfile = true"></i>
                                  </v-radio-group>
                                </v-layout>
                              </div>
                              <div v-else-if="type4 ==='webview'">
                                <v-text-field single-line v-model="urlLink4" label="URL" style="padding-top: 0px !important;"></v-text-field>
                                <v-layout style=" margin-top: 5px;">
                                  <span style="margin-top:10px;">ข้อมูลผู้ใช้ :</span>
                                  <!-- <i class="fas fa-info-circle iconSizeWebview" @click="dialoggetProfile = true"></i> -->
                                  <v-radio-group v-model="profile4" row style="margin-top: 0px !important;">
                                    <v-radio label="ต้องการ" value="true"></v-radio>
                                    <v-radio label="ไม่ต้องการ" value="false"></v-radio>
                                  </v-radio-group>
                                </v-layout>
                                <v-layout v-if="profile4 === 'true'" class="typeProfile" style=" margin-top: 5px;">
                                  <span style="margin-top:10px; margin-right:10px;width: max-content;">ประเภทข้อมูล :</span>
                                  <v-radio-group v-model="signtype4" row hide-details style="width: min-content;">
                                    <v-radio value="sign_share" label="share token"></v-radio>
                                    <i class="fas fa-info-circle iconTypeWebview" @click="dialogShareToken = true"></i>
                                    <v-radio value="sign" label="onechat_token"></v-radio>
                                    <i class="fas fa-info-circle iconTypeWebview" @click="dialoggetProfile = true"></i>
                                  </v-radio-group>
                                </v-layout>
                                <v-layout style=" margin-top: 5px;">
                                  <span style="margin-top:10px; margin-right:10px;width: max-content;">ขนาด :</span>
                                  <i class="fas fa-info-circle iconSizeWebview" @click="dialogSizeWebviewExample = true"></i>
                                  <v-radio-group v-model="showSize4" row style="margin-top: 5px !important;width: min-content;">
                                    <v-radio label="Compact" value="compact"></v-radio>
                                    <v-radio label="Tall" value="tall"></v-radio>
                                    <v-radio label="Full" value="full"></v-radio>
                                  </v-radio-group>
                                </v-layout>
                              </div>
                              <div v-else-if="type4==='text'">
                                <v-text-field single-line v-model="text4" :counter="50" maxlength="50" label="ข้อความ" style="padding-top: 0px !important;margin-bottom: 10px;"></v-text-field>
                              </div>
                              <div v-else-if="type4==='location'">
                                <v-layout class="pb-2 pt-2">
                                  <span style="text-align:left; color:red; font-size:12px;">*</span>
                                  &nbsp;
                                  <span style="text-align:left; color:grey; font-size:12px;"> ระบบจะดึงตำแหน่งที่ตั้งปัจจุบันของผู้ใช้งานไปแสดงในห้องแชทเมื่อมีการเรียกใช้งาน Bottom Menu ประเภทโลเคชัน</span>
                                </v-layout>
                              </div>
                              <div v-else-if="type4==='qrcode'">
                                <v-layout>
                                  <span style="margin-top:10px; margin-right:10px">ต้องการโลเคชัน :</span>
                                  <v-radio-group hide-details v-model="location4" row style="margin-top: 5px !important;">
                                    <v-radio label="ต้องการ" value="true"></v-radio>
                                    <v-radio label="ไม่ต้องการ" value="false"></v-radio>
                                  </v-radio-group>
                                </v-layout>
                                <v-layout class="pb-3 pt-3">
                                  <span style="text-align:left; color:red; font-size:12px;">*</span>
                                  &nbsp;
                                  <span style="text-align:left; color:grey; font-size:12px;">ใช้สำหรับการเปิดตัวอ่านคิวอาร์โค้ด</span>
                                </v-layout>
                              </div>
                            </v-flex>
                          </v-layout>
                          <!-- E -->
                          <v-layout row wrap class="actionTemplateDetailEdit" style="padding-bottom: 10px !important;" v-if="templateDetail[template-1] >= 5">
                            <v-flex xs2 sm2 md2 lg2 x2>
                              <h3>E</h3>
                            </v-flex>
                            <v-flex xs9 sm9 md9 lg9 x9>
                              <v-select :items="type_menu" v-model="type5" style="margin: 0 !important;padding: 0 !important;" @change="clearCardDetail(5)"></v-select>
                              <div v-if="type5==='link' || type5 === 'link_market'">
                                <v-text-field single-line v-model="urlLink5" label="URL" style="padding-top: 0px !important;"></v-text-field>
                                <v-layout v-if="type5 === 'link'" style=" margin-top: 5px;">
                                  <span style="margin-top:10px;">ข้อมูลผู้ใช้ :</span>
                                  <!-- <i class="fas fa-info-circle iconSizeWebview" @click="dialoggetProfile = true"></i> -->
                                  <v-radio-group v-model="profile5" row style="margin-top: 5px !important;">
                                    <v-radio label="ต้องการ" value="true"></v-radio>
                                    <v-radio label="ไม่ต้องการ" value="false"></v-radio>
                                  </v-radio-group>
                                </v-layout>
                                <v-layout v-if="profile5 === 'true' && type5 === 'link'" class="typeProfile" style=" margin-top: 5px;">
                                  <span style="margin-top:10px; margin-right:10px;width: max-content;">ประเภทข้อมูล :</span>
                                  <v-radio-group hide-details v-model="signtype5" row style="width: min-content;">
                                    <v-radio value="sign_share" label="share token"></v-radio>
                                    <i class="fas fa-info-circle iconTypeWebview" @click="dialogShareToken= true"></i>
                                    <v-radio value="sign" label="onechat_token"></v-radio>
                                    <i class="fas fa-info-circle iconTypeWebview" @click="dialoggetProfile = true"></i>
                                  </v-radio-group>
                                </v-layout>
                              </div>
                              <div v-else-if="type5 ==='webview'">
                                <v-text-field single-line v-model="urlLink5" label="URL" style="padding-top: 0px !important;"></v-text-field>
                                <v-layout style=" margin-top: 5px;">
                                  <span style="margin-top:10px;">ข้อมูลผู้ใช้ :</span>
                                  <!-- <i class="fas fa-info-circle iconSizeWebview" @click="dialoggetProfile = true"></i> -->
                                  <v-radio-group v-model="profile5" row style="margin-top: 0px !important;">
                                    <v-radio label="ต้องการ" value="true"></v-radio>
                                    <v-radio label="ไม่ต้องการ" value="false"></v-radio>
                                  </v-radio-group>
                                </v-layout>
                                <v-layout v-if="profile5 === 'true'" class="typeProfile" style=" margin-top: 5px;">
                                  <span style="margin-top:10px; margin-right:10px;width: max-content;">ประเภทข้อมูล :</span>
                                  <v-radio-group v-model="signtype5" row hide-details style="width: min-content;">
                                    <v-radio value="sign_share" label="share token"></v-radio>
                                    <i class="fas fa-info-circle iconTypeWebview" @click="dialogShareToken = true"></i>
                                    <v-radio value="sign" label="onechat_token"></v-radio>
                                    <i class="fas fa-info-circle iconTypeWebview" @click="dialoggetProfile = true"></i>
                                  </v-radio-group>
                                </v-layout>
                                <v-layout style=" margin-top: 5px;">
                                  <span style="margin-top:10px; margin-right:10px;width: max-content;">ขนาด :</span>
                                  <i class="fas fa-info-circle iconSizeWebview" @click="dialogSizeWebviewExample = true"></i>
                                  <v-radio-group v-model="showSize5" row style="margin-top: 5px !important;width: min-content;">
                                    <v-radio label="Compact" value="compact"></v-radio>
                                    <v-radio label="Tall" value="tall"></v-radio>
                                    <v-radio label="Full" value="full"></v-radio>
                                  </v-radio-group>
                                </v-layout>
                              </div>
                              <div v-else-if="type5==='text'">
                                <v-text-field single-line v-model="text5" :counter="50" maxlength="50" label="ข้อความ" style="padding-top: 0px !important;margin-bottom: 10px;"></v-text-field>
                              </div>
                              <div v-else-if="type5 ==='location'">
                                <v-layout class="pb-2 pt-2">
                                  <span style="text-align:left; color:red; font-size:12px;">*</span>
                                  &nbsp;
                                  <span style="text-align:left; color:grey; font-size:12px;"> ระบบจะดึงตำแหน่งที่ตั้งปัจจุบันของผู้ใช้งานไปแสดงในห้องแชทเมื่อมีการเรียกใช้งาน Bottom Menu ประเภทโลเคชัน</span>
                                </v-layout>
                              </div>
                              <div v-else-if="type5==='qrcode'">
                                <v-layout>
                                  <span style="margin-top:10px; margin-right:10px">ต้องการโลเคชัน :</span>
                                  <v-radio-group hide-details v-model="location5" row style="margin-top: 5px !important;">
                                    <v-radio label="ต้องการ" value="true"></v-radio>
                                    <v-radio label="ไม่ต้องการ" value="false"></v-radio>
                                  </v-radio-group>
                                </v-layout>
                                <v-layout class="pb-3 pt-3">
                                  <span style="text-align:left; color:red; font-size:12px;">*</span>
                                  &nbsp;
                                  <span style="text-align:left; color:grey; font-size:12px;">ใช้สำหรับการเปิดตัวอ่านคิวอาร์โค้ด</span>
                                </v-layout>
                              </div>
                            </v-flex>
                          </v-layout>
                          <!-- F -->
                          <v-layout row wrap class="actionTemplateDetailEdit" style="padding-bottom: 10px !important;" v-if="templateDetail[template-1] >= 6">
                            <v-flex xs2 sm2 md2 lg2 x2>
                              <h3>F</h3>
                            </v-flex>
                            <v-flex xs9 sm9 md9 lg9 x9>
                              <v-select :items="type_menu" v-model="type6" style="margin: 0 !important;padding: 0 !important;" @change="clearCardDetail(6)"></v-select>
                              <div v-if="type6==='link' || type6 === 'link_market'">
                                <v-text-field single-line v-model="urlLink6" label="URL" style="padding-top: 0px !important;"></v-text-field>
                                <v-layout v-if="type6 === 'link' " style=" margin-top: 5px;">
                                  <span style="margin-top:10px;">ข้อมูลผู้ใช้ :</span>
                                  <!-- <i class="fas fa-info-circle iconSizeWebview" @click="dialoggetProfile = true"></i> -->
                                  <v-radio-group v-model="profile6" row style="margin-top: 5px !important;">
                                    <v-radio label="ต้องการ" value="true"></v-radio>
                                    <v-radio label="ไม่ต้องการ" value="false"></v-radio>
                                  </v-radio-group>
                                </v-layout>
                                <v-layout v-if="profile6 === 'true' && type6 === 'link'" class="typeProfile" style=" margin-top: 5px;">
                                  <span style="margin-top:10px; margin-right:10px;width: max-content;">ประเภทข้อมูล :</span>
                                  <v-radio-group hide-details v-model="signtype6" row style="width: min-content;">
                                    <v-radio value="sign_share" label="share token"></v-radio>
                                    <i class="fas fa-info-circle iconTypeWebview" @click="dialogShareToken= true"></i>
                                    <v-radio value="sign" label="onechat_token"></v-radio>
                                    <i class="fas fa-info-circle iconTypeWebview" @click="dialoggetProfile = true"></i>
                                  </v-radio-group>
                                </v-layout>
                              </div>
                              <div v-else-if="type6 ==='webview'">
                                <v-text-field single-line v-model="urlLink6" label="URL" style="padding-top: 0px !important;"></v-text-field>
                                <v-layout style=" margin-top: 5px;">
                                  <span style="margin-top:10px;">ข้อมูลผู้ใช้ :</span>
                                  <!-- <i class="fas fa-info-circle iconSizeWebview" @click="dialoggetProfile = true"></i> -->
                                  <v-radio-group v-model="profile6" row style="margin-top: 0px !important;">
                                    <v-radio label="ต้องการ" value="true"></v-radio>
                                    <v-radio label="ไม่ต้องการ" value="false"></v-radio>
                                  </v-radio-group>
                                </v-layout>
                                <v-layout v-if="profile6 === 'true'" class="typeProfile" style=" margin-top: 5px;">
                                  <span style="margin-top:10px; margin-right:10px;width: max-content;">ประเภทข้อมูล :</span>
                                  <v-radio-group v-model="signtype6" row hide-details style="width: min-content;">
                                    <v-radio value="sign_share" label="share token"></v-radio>
                                    <i class="fas fa-info-circle iconTypeWebview" @click="dialogShareToken = true"></i>
                                    <v-radio value="sign" label="onechat_token"></v-radio>
                                    <i class="fas fa-info-circle iconTypeWebview" @click="dialoggetProfile = true"></i>
                                  </v-radio-group>
                                </v-layout>
                                <v-layout style=" margin-top: 5px;">
                                  <span style="margin-top:10px; margin-right:10px;width: max-content;">ขนาด :</span>
                                  <i class="fas fa-info-circle iconSizeWebview" @click="dialogSizeWebviewExample = true"></i>
                                  <v-radio-group v-model="showSize6" row style="margin-top: 5px !important;width: min-content;">
                                    <v-radio label="Compact" value="compact"></v-radio>
                                    <v-radio label="Tall" value="tall"></v-radio>
                                    <v-radio label="Full" value="full"></v-radio>
                                  </v-radio-group>
                                </v-layout>
                              </div>
                              <div v-else-if="type6==='text'">
                                <v-text-field single-line v-model="text6" :counter="50" maxlength="50" label="ข้อความ" style="padding-top: 0px !important;margin-bottom: 10px;"></v-text-field>
                              </div>
                              <div v-else-if="type6==='location'">
                                <v-layout class="pb-2 pt-2">
                                  <span style="text-align:left; color:red; font-size:12px;">*</span>
                                  &nbsp;
                                  <span style="text-align:left; color:grey; font-size:12px;"> ระบบจะดึงตำแหน่งที่ตั้งปัจจุบันของผู้ใช้งานไปแสดงในห้องแชทเมื่อมีการเรียกใช้งาน Bottom Menu ประเภทโลเคชัน</span>
                                </v-layout>
                              </div>
                              <div v-else-if="type6==='qrcode'">
                                <v-layout>
                                  <span style="margin-top:10px; margin-right:10px">ต้องการโลเคชัน :</span>
                                  <v-radio-group hide-details v-model="location6" row style="margin-top: 5px !important;">
                                    <v-radio label="ต้องการ" value="true"></v-radio>
                                    <v-radio label="ไม่ต้องการ" value="false"></v-radio>
                                  </v-radio-group>
                                </v-layout>
                                <v-layout class="pb-3 pt-3">
                                  <span style="text-align:left; color:red; font-size:12px;">*</span>
                                  &nbsp;
                                  <span style="text-align:left; color:grey; font-size:12px;">ใช้สำหรับการเปิดตัวอ่านคิวอาร์โค้ด</span>
                                </v-layout>
                              </div>
                            </v-flex>
                          </v-layout>
                        </v-flex>
                      </v-layout>
                    </div>
                    <div style="margin-top:20px;">
                    </div>
                  </div>
                  <div v-else style="text-align: center;">
                    <h2 style="margin-top:20vh;">ไม่พบข้อมูล BottomMenu ดังกล่าว</h2>
                  </div>
                </v-flex>
              </v-layout>
            </v-container>
          </v-flex>
        </v-layout>
      </v-container>
    </v-card-text>
    <SizeWebviewExampleDialog :dialogSizeWebviewExample="dialogSizeWebviewExample" @closeDialogSizeWebviewExample="closeDialogSizeWebviewExample" />
    <HowtoGetProfileDialog :dialoggetProfile="dialoggetProfile" @closeDialoggetProfile="closeDialoggetProfile" />
    <dialogShareToken :dialogShareToken="dialogShareToken" @closeDialogshareToken="closeDialogshareToken" />
  </div>
</template>
<script>
import SizeWebviewExampleDialog from '@/components/managebot/bottommenu/dialog/size_webviewDialog'
import HowtoGetProfileDialog from '@/components/managebot/bottommenu/dialog/howto_getprofileDialog'
import dialogShareToken from '@/components/managebot/bottommenu/dialog/howto_getsharetokenDialog'
export default {
  data () {
    return {
      stateProcess: 'showDetail',
      // stateProcess: 'editBottomMenu',
      dialogSizeWebviewExample: false,
      dialoggetProfile: false,
      dialogShareToken: false,
      statusLink_market: '',
      type_menu: [
        { text: 'ลิงก์', value: 'link' },
        { text: 'เว็บวิว', value: 'webview' },
        { text: 'ข้อความ', value: 'text' }
      ],
      tokenbot: '',
      token: '',
      bottommenu_id: '',
      statusRichMenu: true,
      showBasicMenu: true,
      nameBottom: 'Menu',
      templateDetail: [ 6, 4, 4, 3, 2, 2, 1, 3, 2, 2, 2, 1 , 4 ],
      A_F: ['A', 'B', 'C', 'D', 'E', 'F'],
      nameBottomRule: [
        v => !!v || 'โปรดใส่ข้อความ',
        v => v.length <= 14 || 'ข้อความต้องน้อยกว่า 14 ตัวอักษร'
      ],
      data: {},
      image: null,
      image2: null,
      image3: null,
      image4: null,
      image5: null,
      image6: null,
      url: null,
      url2: null,
      url3: null,
      url4: null,
      url5: null,
      url6: null,
      type: null,
      type2: null,
      type3: null,
      type4: null,
      type5: null,
      type6: null,
      profile: 'false',
      profile2: 'false',
      profile3: 'false',
      profile4: 'false',
      profile5: 'false',
      profile6: 'false',
      sign: 'true',
      sign2: 'true',
      sign3: 'true',
      sign4: 'true',
      sign5: 'true',
      sign6: 'true',
      sign_share: 'false',
      sign_share2: 'false',
      sign_share3: 'false',
      sign_share4: 'false',
      sign_share5: 'false',
      sign_share6: 'false',
      signtype: 'sign',
      signtype2: 'sign',
      signtype3: 'sign',
      signtype4: 'sign',
      signtype5: 'sign',
      signtype6: 'sign',
      showSize: 'compact',
      showSize2: 'compact',
      showSize3: 'compact',
      showSize4: 'compact',
      showSize5: 'compact',
      showSize6: 'compact',
      urlLink: '',
      urlLink2: '',
      urlLink3: '',
      urlLink4: '',
      urlLink5: '',
      urlLink6: '',
      text: '',
      text2: '',
      text3: '',
      text4: '',
      text5: '',
      text6: '',
      location: 'false',
      location2: 'false',
      location3: 'false',
      location4: 'false',
      location5: 'false',
      location6: 'false',
    }
  },
  methods: {
    closeDialogSizeWebviewExample (value) {
      this.dialogSizeWebviewExample = value
    },
    closeDialoggetProfile (value) {
      this.dialoggetProfile = value
    },
    closeDialogshareToken (value) {
      this.dialogShareToken = value
    },
    disabledBtnCreate () {
      if (this.nameBottom) {
        if (this.template === 1) {
          // console.log('1 ::: ' + this.checktype1())
          // console.log('2 ::: ' + this.checktype2())
          // console.log('3 ::: ' + this.checktype3())
          // console.log('4 ::: ' + this.checktype4())
          // console.log('5 ::: ' + this.checktype5())
          // console.log('6 ::: ' + this.checktype6())
          // console.log('image ::: ' + this.checkImage(6))
          return this.checktype1() || this.checktype2() || this.checktype3() || this.checktype4() || this.checktype5() || this.checktype6() || this.checkImage(6)
        } else if (this.template === 2 || this.template === 3 || this.template === 13) {
          return this.checktype1() || this.checktype2() || this.checktype3() || this.checktype4() || this.checkImage(4)
        } else if (this.template === 4 || this.template === 8) {
          return this.checktype1() || this.checktype2() || this.checktype3() || this.checkImage(3)
        } else if (this.template === 5 || this.template === 6 || this.template === 9 || this.template === 10 || this.template === 11) {
          return this.checktype1() || this.checktype2() || this.checkImage(2)
        } else if (this.template === 7 || this.template === 12) {
          return this.checktype1() || this.checkImage(1)
        } else {
          return true
        }
      } else {
        return true
      }
    },
    checkImage (number) {
      if (number === 6) {
        return (this.url === null || this.url2 === null || this.url3 === null || this.url4 === null || this.url5 === null || this.url6 === null)
      } else if (number === 4) {
        return (this.url === null || this.url2 === null || this.url3 === null || this.url4 === null)
      } else if (number === 3) {
        return (this.url === null || this.url2 === null || this.url3 === null)
      } else if (number === 2) {
        return (this.url === null || this.url2 === null)
      } else {
        return (this.url === null)
      }
    },
    checktype1 () {
      if ((this.type === 'link' || this.type === 'link_market') && this.profile && this.urlLink) {
        return false
      } else if (this.type === 'webview' && this.profile && this.showSize && this.urlLink) {
        return false
      } else if (this.type === 'text' && this.text) {
        return false
      } else if (this.type === 'location') {
        return false
      } else if (this.type === 'qrcode') {
        return false
      } else {
        return true
      }
    },
    checktype2 () {
      if ((this.type2 === 'link' || this.type2 === 'link_market') && this.profile2 && this.urlLink2) {
        return false
      } else if (this.type2 === 'webview' && this.profile2 && this.showSize2 && this.urlLink2) {
        return false
      } else if (this.type2 === 'text' && this.text2) {
        return false
      } else if (this.type2 === 'location') {
        return false
      } else if (this.type2 === 'qrcode') {
        return false
      } else {
        return true
      }
    },
    checktype3 () {
      if ((this.type3 === 'link' || this.type3 === 'link_market') && this.profile3 && this.urlLink3) {
        return false
      } else if (this.type3 === 'webview' && this.profile3 && this.showSize3 && this.urlLink3) {
        return false
      } else if (this.type3 === 'text' && this.text3) {
        return false
      } else if (this.type3 === 'location') {
        return false
      } else if (this.type3 === 'qrcode') {
        return false
      } else {
        return true
      }
    },
    checktype4 () {
      if ((this.type4 === 'link' || this.type4 === 'link_market') && this.profile4 && this.urlLink4) {
        return false
      } else if (this.type4 === 'webview' && this.profile4 && this.showSize4 && this.urlLink4) {
        return false
      } else if (this.type4 === 'text' && this.text4) {
        return false
      } else if (this.type4 === 'location') {
        return false
      } else if (this.type4 === 'qrcode') {
        return false
      } else {
        return true
      }
    },
    checktype5 () {
      if ((this.type5 === 'link' || this.type5 === 'link_market') && this.profile5 && this.urlLink5) {
        return false
      } else if (this.type5 === 'webview' && this.profile5 && this.showSize5 && this.urlLink5) {
        return false
      } else if (this.type5 === 'text' && this.text5) {
        return false
      } else if (this.type5 === 'location') {
        return false
      } else if (this.type5 === 'qrcode') {
        return false
      } else {
        return true
      }
    },
    checktype6 () {
      if ((this.type6 === 'link' || this.type6 === 'link_market') && this.profile6 && this.urlLink6) {
        return false
      } else if (this.type6 === 'webview' && this.profile6 && this.showSize6 && this.urlLink6) {
        return false
      } else if (this.type6 === 'text' && this.text6) {
        return false
      } else if (this.type6 === 'location') {
        return false
      } else if (this.type6 === 'qrcode') {
        return false
      } else {
        return true
      }
    },
    checkState_market () {
      var body = {bot_id: this.tokenbot}
      this.$http.post(process.env.APImanage + '/check_rolebot', body).then((response) => {
        // console.log(response.body)
        if (response.body['status'] === 'success') {
          this.statusLink_market = true
        } else {
          this.statusLink_market = false
        }
      }, (response) => {})
    },
    return1_0 (status) {
      if (status === true || status === 'true' || status === '1') {
        return '1'
      } else {
        return '0'
      }
    },
    chooseImage () {
      this.$refs.fileInput.click()
    },
    chooseImage2 () {
      this.$refs.fileInput2.click()
    },
    chooseImage3 () {
      this.$refs.fileInput3.click()
    },
    chooseImage4 () {
      this.$refs.fileInput4.click()
    },
    chooseImage5 () {
      this.$refs.fileInput5.click()
    },
    chooseImage6 () {
      this.$refs.fileInput6.click()
    },
    onSelectfile (data) {
      var input = this.$refs.fileInput
      var files = input.files
      this.image = data.target.files[0]

      if (files && files[0]) {
        this.url = URL.createObjectURL(data.target.files[0])
      }
    },
    onSelectfile2 (data) {
      var input = this.$refs.fileInput2
      var files = input.files
      this.image2 = data.target.files[0]

      if (files && files[0]) {
        this.url2 = URL.createObjectURL(files[0])
      }
    },
    onSelectfile3 (data) {
      var input = this.$refs.fileInput3
      var files = input.files
      this.image3 = data.target.files[0]

      if (files && files[0]) {
        this.url3 = URL.createObjectURL(files[0])
      }
    },
    onSelectfile4 (data) {
      var input = this.$refs.fileInput4
      var files = input.files
      this.image4 = data.target.files[0]

      if (files && files[0]) {
        this.url4 = URL.createObjectURL(files[0])
      }
    },
    onSelectfile5 (data) {
      var input = this.$refs.fileInput5
      var files = input.files
      this.image5 = data.target.files[0]

      if (files && files[0]) {
        this.url5 = URL.createObjectURL(files[0])
      }
    },
    onSelectfile6 (data) {
      var input = this.$refs.fileInput6
      var files = input.files
      this.image6 = data.target.files[0]

      if (files && files[0]) {
        this.url6 = URL.createObjectURL(files[0])
      }
    },
    editBottom () {
      var body = {
        bot_id: this.tokenbot,
        rich_menu_id: this.bottommenu_id,
        menu_label: this.nameBottom,
        richmenu_status: this.return1_0(this.statusRichMenu),
        default_behavior: this.return1_0(this.showBasicMenu)
      }
      this.$http.post(process.env.APImanage + '/set_richmenu', body).then((response) => {
        if (response.body.status === 'success') {
          this.$swal(
            'การแก้ไข Bottom Menu',
            'Bottom Menuถูกแก้ไขแล้ว.',
            'success'
          )
          this.$router.push('/develop/bottommenu/list/' + this.tokenbot)
        }
      }, (response) => {})
    },
    editBottomMenu () {
      var uploadFile = new FormData()
      uploadFile.append('bot_id', this.tokenbot)
      uploadFile.append('create_by', this.token)
      uploadFile.append('menu_label', this.nameBottom)
      uploadFile.append('rich_menu_id', this.bottommenu_id)
      uploadFile.append('richmenu_name', this.data.richmenu_name)
      uploadFile.append('richmenu_status', this.return1_0(this.statusRichMenu))
      uploadFile.append('default_behavior', this.return1_0(this.showBasicMenu))
      uploadFile.append('type_menu', this.template.toString())
      if (this.image) {
        uploadFile.append('picture1', this.image, this.image.name)
      } else {
        uploadFile.append('picture1', '')
      }
      uploadFile.append('type1', this.type)
      if (this.type === 'text') {
        uploadFile.append('message1', this.text)
      } else if (this.type === 'webview') {
        uploadFile.append('url1', this.urlLink)
        uploadFile.append('size1', this.showSize)
        if (this.profile === 'true') {
          if (this.signtype === 'sign_share') {
            uploadFile.append('sign_share1', 'true')
            uploadFile.append('sign1', 'false')
          } else if (this.signtype === 'sign') {
            uploadFile.append('sign_share1', 'false')
            uploadFile.append('sign1', 'true')
          }
        } else {
          uploadFile.append('sign_share1', 'false')
          uploadFile.append('sign1', 'false')
        }
      } else if (this.type === 'link') {
        uploadFile.append('url1', this.urlLink)
        if (this.profile === 'true') {
          if (this.signtype === 'sign_share') {
            uploadFile.append('sign_share1', 'true')
            uploadFile.append('sign1', 'false')
          } else if (this.signtype === 'sign') {
            uploadFile.append('sign_share1', 'false')
            uploadFile.append('sign1', 'true')
          }
        } else {
          uploadFile.append('sign_share1', 'false')
          uploadFile.append('sign1', 'false')
        }
      } else if (this.type === 'link_market') {
        uploadFile.append('url1', this.urlLink)
        uploadFile.append('sign_share1', 'false')
        uploadFile.append('sign1', 'false')
      } else if (this.type === 'qrcode'){
        if(this.location === 'true'){
          uploadFile.append('location_status1', 'true')
        }else {
          uploadFile.append('location_status1', 'false')
        }
      }

      if (this.templateDetail[this.template - 1] >= 2) {
        // uploadFile.append('picture2', '')
        if (this.image2) {
          uploadFile.append('picture2', this.image2, this.image2.name)
        } else {
          uploadFile.append('picture2', '')
        }
        uploadFile.append('type2', this.type2)
        if (this.type2 === 'text') {
          uploadFile.append('message2', this.text2)
        } else if (this.type2 === 'webview') {
          uploadFile.append('url2', this.urlLink2)
          uploadFile.append('size2', this.showSize2)
          if (this.profile2 === 'true') {
            if (this.signtype2 === 'sign_share') {
              uploadFile.append('sign_share2', 'true')
              uploadFile.append('sign2', 'false')
            } else if (this.signtype2 === 'sign') {
              uploadFile.append('sign_share2', 'false')
              uploadFile.append('sign2', 'true')
            }
          } else {
            uploadFile.append('sign_share2', 'false')
            uploadFile.append('sign2', 'false')
          }
        } else if (this.type2 === 'link') {
          uploadFile.append('url2', this.urlLink2)
          if (this.profile2 === 'true') {
            if (this.signtype2 === 'sign_share') {
              uploadFile.append('sign_share2', 'true')
              uploadFile.append('sign2', 'false')
            } else if (this.signtype2 === 'sign') {
              uploadFile.append('sign_share2', 'false')
              uploadFile.append('sign2', 'true')
            }
          } else {
            uploadFile.append('sign_share2', 'false')
            uploadFile.append('sign2', 'false')
          }
        } else if (this.type2 === 'link_market') {
          uploadFile.append('url2', this.urlLink2)
          uploadFile.append('sign_share2', 'false')
          uploadFile.append('sign2', 'false')
        } else if (this.type2 === 'qrcode'){
          if(this.location2 === 'true'){
            uploadFile.append('location_status2', 'true')
          }else {
            uploadFile.append('location_status2', 'false')
          }
        }
      }

      if (this.templateDetail[this.template - 1] >= 3) {
        // uploadFile.append('picture3', '')
        if (this.image3) {
          uploadFile.append('picture3', this.image3, this.image3.name)
        } else {
          uploadFile.append('picture3', '')
        }
        uploadFile.append('type3', this.type3)
        if (this.type3 === 'text') {
          uploadFile.append('message3', this.text3)
        } else if (this.type3 === 'webview') {
          uploadFile.append('url3', this.urlLink3)
          uploadFile.append('size3', this.showSize3)
          if (this.profile3 === 'true') {
            if (this.signtype3 === 'sign_share') {
              uploadFile.append('sign_share3', 'true')
              uploadFile.append('sign3', 'false')
            } else if (this.signtype3 === 'sign') {
              uploadFile.append('sign_share3', 'false')
              uploadFile.append('sign3', 'true')
            }
          } else {
            uploadFile.append('sign_share3', 'false')
            uploadFile.append('sign3', 'false')
          }
        } else if (this.type3 === 'link') {
          uploadFile.append('url3', this.urlLink3)
          if (this.profile3 === 'true') {
            if (this.signtype3 === 'sign_share') {
              uploadFile.append('sign_share3', 'true')
              uploadFile.append('sign3', 'false')
            } else if (this.signtype3 === 'sign') {
              uploadFile.append('sign_share3', 'false')
              uploadFile.append('sign3', 'true')
            }
          } else {
            uploadFile.append('sign_share3', 'false')
            uploadFile.append('sign3', 'false')
          }
        } else if (this.type3 === 'link_market') {
          uploadFile.append('url3', this.urlLink3)
          uploadFile.append('sign_share3', 'false')
          uploadFile.append('sign3', 'false')
        } else if (this.type3 === 'qrcode'){
          if(this.location3 === 'true'){
            uploadFile.append('location_status3', 'true')
          }else {
            uploadFile.append('location_status3', 'false')
          }
        }
      }

      if (this.templateDetail[this.template - 1] >= 4) {
        // uploadFile.append('picture4', '')
        if (this.image4) {
          uploadFile.append('picture4', this.image4, this.image4.name)
        } else {
          uploadFile.append('picture4', '')
        }
        uploadFile.append('type4', this.type4)
        if (this.type4 === 'text') {
          uploadFile.append('message4', this.text4)
        } else if (this.type4 === 'webview') {
          uploadFile.append('url4', this.urlLink4)
          uploadFile.append('size4', this.showSize4)
          if (this.profile4 === 'true') {
            if (this.signtype4 === 'sign_share') {
              uploadFile.append('sign_share4', 'true')
              uploadFile.append('sign4', 'false')
            } else if (this.signtype4 === 'sign') {
              uploadFile.append('sign_share4', 'false')
              uploadFile.append('sign4', 'true')
            }
          } else {
            uploadFile.append('sign_share4', 'false')
            uploadFile.append('sign4', 'false')
          }
        } else if (this.type4 === 'link') {
          uploadFile.append('url4', this.urlLink4)
          if (this.profile4 === 'true') {
            if (this.signtype4 === 'sign_share') {
              uploadFile.append('sign_share4', 'true')
              uploadFile.append('sign4', 'false')
            } else if (this.signtype4 === 'sign') {
              uploadFile.append('sign_share4', 'false')
              uploadFile.append('sign4', 'true')
            }
          } else {
            uploadFile.append('sign_share4', 'false')
            uploadFile.append('sign4', 'false')
          }
        } else if (this.type4 === 'link_market') {
          uploadFile.append('url4', this.urlLink4)
          uploadFile.append('sign_share4', 'false')
          uploadFile.append('sign4', 'false')
        } else if (this.type4 === 'qrcode'){
          if(this.location4 === 'true'){
            uploadFile.append('location_status4', 'true')
          }else {
            uploadFile.append('location_status4', 'false')
          }
        }
      }

      if (this.templateDetail[this.template - 1] >= 5) {
        // uploadFile.append('picture5', '')
        if (this.image5) {
          uploadFile.append('picture5', this.image5, this.image5.name)
        } else {
          uploadFile.append('picture5', '')
        }
        uploadFile.append('type5', this.type5)
        if (this.type5 === 'text') {
          uploadFile.append('message5', this.text5)
        } else if (this.type5 === 'webview') {
          uploadFile.append('url5', this.urlLink5)
          uploadFile.append('size5', this.showSize5)
          if (this.profile5 === 'true') {
            if (this.signtype5 === 'sign_share') {
              uploadFile.append('sign_share5', 'true')
              uploadFile.append('sign5', 'false')
            } else if (this.signtype5 === 'sign') {
              uploadFile.append('sign_share5', 'false')
              uploadFile.append('sign5', 'true')
            }
          } else {
            uploadFile.append('sign_share5', 'false')
            uploadFile.append('sign5', 'false')
          }
        } else if (this.type5 === 'link') {
          uploadFile.append('url5', this.urlLink5)
          if (this.profile5 === 'true') {
            if (this.signtype5 === 'sign_share') {
              uploadFile.append('sign_share5', 'true')
              uploadFile.append('sign5', 'false')
            } else if (this.signtype5 === 'sign') {
              uploadFile.append('sign_share5', 'false')
              uploadFile.append('sign5', 'true')
            }
          } else {
            uploadFile.append('sign_share5', 'false')
            uploadFile.append('sign5', 'false')
          }
        } else if (this.type5 === 'link_market') {
          uploadFile.append('url5', this.urlLink5)
          uploadFile.append('sign_share5', 'false')
          uploadFile.append('sign5', 'false')
        } else if (this.type5 === 'qrcode'){
          if(this.location5 === 'true'){
            uploadFile.append('location_status5', 'true')
          }else {
            uploadFile.append('location_status5', 'false')
          }
        }
      }

      if (this.templateDetail[this.template - 1] === 6) {
        // uploadFile.append('picture6', '')
        if (this.image6) {
          uploadFile.append('picture6', this.image6, this.image6.name)
        } else {
          uploadFile.append('picture6', '')
        }
        uploadFile.append('type6', this.type6)
        if (this.type6 === 'text') {
          uploadFile.append('message6', this.text6)
        } else if (this.type6 === 'webview') {
          uploadFile.append('url6', this.urlLink6)
          uploadFile.append('size6', this.showSize6)
          if (this.profile6 === 'true') {
            if (this.signtype6 === 'sign_share') {
              uploadFile.append('sign_share6', 'true')
              uploadFile.append('sign6', 'false')
            } else if (this.signtype6 === 'sign') {
              uploadFile.append('sign_share6', 'false')
              uploadFile.append('sign6', 'true')
            }
          } else {
            uploadFile.append('sign_share6', 'false')
            uploadFile.append('sign6', 'false')
          }
        } else if (this.type6 === 'link') {
          uploadFile.append('url6', this.urlLink6)
          if (this.profile6 === 'true') {
            if (this.signtype6 === 'sign_share') {
              uploadFile.append('sign_share6', 'true')
              uploadFile.append('sign6', 'false')
            } else if (this.signtype6 === 'sign') {
              uploadFile.append('sign_share6', 'false')
              uploadFile.append('sign6', 'true')
            }
          } else {
            uploadFile.append('sign_share6', 'false')
            uploadFile.append('sign6', 'false')
          }
        } else if (this.type6 === 'link_market') {
          uploadFile.append('url6', this.urlLink6)
          uploadFile.append('sign_share6', 'false')
          uploadFile.append('sign6', 'false')
        } else if (this.type6 === 'qrcode'){
          if(this.location6 === 'true'){
            uploadFile.append('location_status6', 'true')
          }else {
            uploadFile.append('location_status6', 'false')
          }
        }

        // else if (this.type)
      }

    // console.log(...uploadFile)

      this.$swal({
        title: 'คุณแน่ใจหรือไม่?',
        text: 'คุณต้องการยืนยันการแก้ไขใช่หรือไม่',
        type: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#d33',
        cancelButtonColor: '#3085d6',
        confirmButtonText: 'ใช่',
        cancelButtonText: 'ไม่ใช่',
        confirmButtonClass: 'btn btn-danger',
        cancelButtonClass: 'btn btn-success',
        buttonsStyling: true,
        showCloseButton: true,
        reverseButtons: true
      }).then((result) => {
        if (result.value) {
          this.$http.post(process.env.APImanage + '/v4/edit_richmenu', uploadFile).then((response) => {
            // console.log(response)
            if (response.body.status === 'success') {
              this.$swal(
                'การแก้ไข Bottom Menu',
                'Bottom Menuถูกแก้ไขแล้ว.',
                'success'
              )
              // this.$router.push('/develop/bottommenu/list/' + this.tokenbot)
              this.getBottomMenu()
              this.stateProcess = 'showDetail'
            }
          }, (response) => {
          })
        }
      })
    },
    cancelEdit () {
      this.$swal({
        title: 'คุณแน่ใจหรือไม่?',
        text: 'คุณต้องการยกเลิกการแก้ไขใช่หรือไม่',
        type: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#d33',
        cancelButtonColor: '#3085d6',
        confirmButtonText: 'ใช่',
        cancelButtonText: 'ไม่ใช่',
        confirmButtonClass: 'btn btn-danger',
        cancelButtonClass: 'btn btn-success',
        buttonsStyling: true,
        showCloseButton: true,
        reverseButtons: true
      }).then((result) => {
        if (result.value) {
          this.stateProcess = 'showDetail'
        }
      })
    },
    backlink () {
      if (this.checkDisabledEdit() || this.data.status === 'fail') {
        this.$router.go(-1)
      } else {
        this.$swal({
          title: 'คุณแน่ใจหรือไม่?',
          text: 'คุณต้องการยกเลิกการแก้ไขใช่หรือไม่',
          type: 'warning',
          showCancelButton: true,
          confirmButtonColor: '#d33',
          cancelButtonColor: '#3085d6',
          confirmButtonText: 'ใช่',
          cancelButtonText: 'ไม่ใช่',
          confirmButtonClass: 'btn btn-danger',
          cancelButtonClass: 'btn btn-success',
          buttonsStyling: true,
          showCloseButton: true,
          reverseButtons: true
        }).then((result) => {
          if (result.value) {
            this.$router.go(-1)
          }
        })
      }
    },
    getBottomMenu () {
      var body = {bot_id: this.tokenbot, rich_menu_id: this.bottommenu_id}
      this.$http.post(process.env.APImanage + '/get_richmenu', body).then((response) => {
        // console.log(process.env.APImanage)
        this.data = response.body
        // console.log(this.data)
        if (response.body.status === 'success') {
          this.nameBottom = this.data.menu_label
          this.statusRichMenu = (this.data.richmenu_status === '1')
          this.showBasicMenu = (this.data.default_behavior === '1')
          this.template = parseInt(response.body.type_menu)
          this.manageData_edit(response.body)
        }
      }, (response) => {})
    },
    backgroundDiv (path, width, height) {
      return 'height: ' + height + 'px; width: ' + width + 'px; border: 1px solid black; background: url(\'' + path + '\';background-position: center !important; background-size: cover !important;'
    },
    checkDisabledEdit () {
      if (this.statusRichMenu !== (this.data.richmenu_status === '1')) {
        return false
      } else if (this.showBasicMenu !== (this.data.default_behavior === '1')) {
        return false
      } else if (this.nameBottom !== this.data.menu_label) {
        return false
      } else {
        return true
      }
    },
    checkTypeTH (type) {
      if (type === 'link') {
        return 'ลิงก์'
      } else if (type === 'link_market') {
        return 'ลิงก์ market'
      } else if (type === 'webview') {
        return 'เว็บวิว'
      } else if (type === 'text') {
        return 'ข้อความ'
      } else if (type === 'location') {
        return 'โลเคชัน'
      } else if (type === 'qrcode') {
        return 'คิวอาร์โค้ด'
      } else {
        return 'ไม่พบข้อมูลดังกล่าว'
      }
    },
    DeleteBottomMenu () {
      this.$swal({
        title: 'คุณต้องการลบ BottomMenu นี้ใช่หรือไม่?',
        type: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#d33',
        cancelButtonColor: '#3085d6',
        confirmButtonText: 'ตกลง',
        cancelButtonText: 'ยกเลิก',
        confirmButtonClass: 'btn btn-danger',
        cancelButtonClass: 'btn btn-success',
        reverseButtons: true,
        buttonsStyling: true,
        showCloseButton: true
      }).then((result) => {
        if (result.value) {
          var body = {
            rich_menu_id: this.bottommenu_id,
            bot_id: this.tokenbot
          }
          this.$http.post(process.env.APImanage + '/remove_richmenu', body).then(response => {
            // console.log(response.body)
            if (response.body['status'] === 'success') {
              this.$swal(
                'ลบแล้ว!',
                'BottomMenu นี้ถูกลบแล้ว',
                'success'
              )
              this.backlink()
            }
          })
        }
      })
    },
    data1 (listmenu) {
      // console.log(listmenu)
      this.url = listmenu.picture
      this.text = listmenu.message
      this.sign = listmenu.sign
      this.sign_share = listmenu.sign_share
      this.showSize = (listmenu.size) ? listmenu.size : 'compact'
      this.type = listmenu.type
      this.urlLink = listmenu.url
      if (this.sign === 'true' || this.sign_share === 'true') {
        this.profile = 'true'
        if (this.sign === 'true') {
          this.signtype = 'sign'
        } else if (this.sign_share === 'true') {
          this.signtype = 'sign_share'
        }
      }
      if (listmenu.location_status === 'true'){
        this.location = 'true'
      }else {
        this.location = 'false'
      }
    },
    data2 (listmenu) {
      this.url2 = listmenu.picture
      this.text2 = listmenu.message
      this.sign2 = listmenu.sign
      this.sign_share2 = listmenu.sign_share
      this.showSize2 = (listmenu.size) ? listmenu.size : 'compact'
      this.type2 = listmenu.type
      this.urlLink2 = listmenu.url
      if (this.sign2 === 'true' || this.sign_share2 === 'true') {
        this.profile2 = 'true'
        if (this.sign2 === 'true') {
          this.signtype2 = 'sign'
        } else if (this.sign_share2 === 'true') {
          this.signtype2 = 'sign_share'
        }
      }
      if (listmenu.location_status === 'true'){
        this.location2 = 'true'
      }else {
        this.location2 = 'false'
      }
    },
    data3 (listmenu) {
      this.url3 = listmenu.picture
      this.text3 = listmenu.message
      this.sign3 = listmenu.sign
      this.sign_share3 = listmenu.sign_share
      this.showSize3 = (listmenu.size) ? listmenu.size : 'compact'
      this.type3 = listmenu.type
      this.urlLink3 = listmenu.url
      if (this.sign3 === 'true' || this.sign_share3 === 'true') {
        this.profile3 = 'true'
        if (this.sign3 === 'true') {
          this.signtype3 = 'sign'
        } else if (this.sign_share3 === 'true') {
          this.signtype3 = 'sign_share'
        }
      }if (listmenu.location_status === 'true'){
        this.location3 = 'true'
      }else {
        this.location3 = 'false'
      }
    },
    data4 (listmenu) {
      this.url4 = listmenu.picture
      this.text4 = listmenu.message
      this.sign4 = listmenu.sign
      this.sign_share4 = listmenu.sign_share
      this.showSize4 = (listmenu.size) ? listmenu.size : 'compact'
      this.type4 = listmenu.type
      this.urlLink4 = listmenu.url
      if (this.sign4 === 'true' || this.sign_share4 === 'true') {
        this.profile4 = 'true'
        if (this.sign4 === 'true') {
          this.signtype4 = 'sign'
        } else if (this.sign_share4 === 'true') {
          this.signtype4 = 'sign_share'
        }
      } if (listmenu.location_status === 'true'){
        this.location4 = 'true'
      }else {
        this.location4 = 'false'
      }
    },
    data5 (listmenu) {
      this.url5 = listmenu.picture
      this.text5 = listmenu.message
      this.sign5 = listmenu.sign
      this.sign_share5 = listmenu.sign_share
      this.showSize5 = (listmenu.size) ? listmenu.size : 'compact'
      this.type5 = listmenu.type
      this.urlLink5 = listmenu.url
      if (this.sign5 === 'true' || this.sign_share5 === 'true') {
        this.profile5 = 'true'
        if (this.sign5 === 'true') {
          this.signtype5 = 'sign'
        } else if (this.sign_share5 === 'true') {
          this.signtype5 = 'sign_share'
        }
      } if (listmenu.location_status === 'true'){
        this.location5 = 'true'
      }else {
        this.location5 = 'false'
      }
    },
    data6 (listmenu) {
      this.url6 = listmenu.picture
      this.text6 = listmenu.message
      this.sign6 = listmenu.sign
      this.sign_share6 = listmenu.sign_share
      this.showSize6 = (listmenu.size) ? listmenu.size : 'compact'
      this.type6 = listmenu.type
      this.urlLink6 = listmenu.url
      if (this.sign6 === 'true' || this.sign_share6 === 'true') {
        this.profile6 = 'true'
        if (this.sign6 === 'true') {
          this.signtype6 = 'sign'
        } else if (this.sign_share6 === 'true') {
          this.signtype6 = 'sign_share'
        }
      }if (listmenu.location_status === 'true'){
        this.location6 = 'true'
      }else {
        this.location6 = 'false'
      }
    },
    manageData_edit (data) {
      if (parseInt(data.type_menu) === 1) {
        this.data1(data.list_menu[0])
        this.data2(data.list_menu[1])
        this.data3(data.list_menu[2])
        this.data4(data.list_menu[3])
        this.data5(data.list_menu[4])
        this.data6(data.list_menu[5])
      } else if (parseInt(data.type_menu) === 2 || parseInt(data.type_menu) === 3 || parseInt(data.type_menu) === 13) {
        this.data1(data.list_menu[0])
        this.data2(data.list_menu[1])
        this.data3(data.list_menu[2])
        this.data4(data.list_menu[3])
      } else if (parseInt(data.type_menu) === 4 || parseInt(data.type_menu) === 8) {
        this.data1(data.list_menu[0])
        this.data2(data.list_menu[1])
        this.data3(data.list_menu[2])
      } else if (parseInt(data.type_menu) === 5 || parseInt(data.type_menu) === 6 || parseInt(data.type_menu) === 9 || parseInt(data.type_menu) === 10 || parseInt(data.type_menu) === 11) {
        this.data1(data.list_menu[0])
        this.data2(data.list_menu[1])
      } else if (parseInt(data.type_menu) === 7 || parseInt(data.type_menu) === 12) {
        this.data1(data.list_menu[0])
      }
    },
    clearCardDetail(index = '') {
      const urlLinkKey = `urlLink${index}`
      const textKey = `text${index}`

      this[urlLinkKey] = ''
      this[textKey] = ''
    }
  },
  components: {
    SizeWebviewExampleDialog,
    HowtoGetProfileDialog,
    dialogShareToken
  },
  watch: {
    statusLink_market () {
      if (this.statusLink_market) {
        this.type_menu = [
          { text: 'ลิงก์', value: 'link' },
          { text: 'ลิงก์ market', value: 'link_market' },
          { text: 'เว็บวิว', value: 'webview' },
          { text: 'ข้อความ', value: 'text' },
          { text: 'โลเคชัน', value: 'location' },
          { text: 'คิวอาร์โค้ด', value: 'qrcode' }
        ]
      } else {
        this.type_menu = [
          { text: 'ลิงก์', value: 'link' },
          { text: 'เว็บวิว', value: 'webview' },
          { text: 'ข้อความ', value: 'text' },
          { text: 'โลเคชัน', value: 'location' },
          { text: 'คิวอาร์โค้ด', value: 'qrcode' }
        ]
      }
    }
  },
  created () {
    this.token = localStorage.getItem('tokenuser')
    this.tokenbot = this.$route.params.tokenbot
    this.bottommenu_id = this.$route.params.bottommenu_id
    this.checkState_market()
    this.getBottomMenu()
  }
}
</script>
<style type="text/css" scoped>
.v-text-field.v-text-field--enclosed .v-text-field__details {
  margin-bottom: 0px !important;
}

.v-card {
  border-radius: 2px;
  box-shadow: none;
  display: block;
  min-width: 0;
  position: relative;
  text-decoration: none;
  transition: .3s cubic-bezier(.25, .8, .5, 1);
}

.v-messages__message {
  -ms-hyphens: auto;
  -webkit-hyphens: auto;
  hyphens: auto;
  line-height: 2;
  overflow-wrap: break-word;
  word-break: break-word;
  word-wrap: break-word;
}

.v-text-field.v-text-field--solo:not(.v-text-field--solo-flat) .v-input__slot {
  box-shadow: none !important;
  border-style: solid;
  border-width: thin;
  border-radius: 5px;
  border-color: #d2d8dd;
}

.v-text-field.v-text-field--solo .v-input__control {
  min-height: 42px !important;
  padding: 0 !important;
}

.buttonclear {
  border-style: solid !important;
  border-radius: 5px !important;
  background-color: #bdbdbd !important;
  border-color: #bdbdbd !important;
  width: 105px !important;
  box-shadow: none !important;
}

.buttoncreate {
  border-style: solid !important;
  border-radius: 5px !important;
  background-color: #2562af !important;
  /* border-color: #bdbdbd !important; */
  width: 105px !important;
  color: white !important;
  box-shadow: none !important;
}

.Kanit {
  font-family: 'Kanit', sans-serif !important;
  word-wrap: break-word;
}

.edit {
  font-weight: 100;
}

.inputWrapper {
  height: 32px;
  width: 90px;
  overflow: hidden;
  position: relative;
  cursor: pointer;
  /*margin-top: 5vh;*/
  /*Using a background color, but you can use a background image to represent a button*/
  /*background-color: #DDF;*/
}

.img {
  display: block;
  max-width: 230px;
  max-height: 95px;
  width: auto;
  height: auto;
}

.alligator-turtle {
  object-fit: cover;
  object-position: 50% 0;
}

.dialog .dialog--active .dialog--persistent {
  max-height: 107vh;
  overflow: hidden;
}

.card__text {
  padding-left: 16px;
  padding-right: 16px;
  padding-bottom: 16px;
  overflow: hidden;
}

.CSChatThai {
  font-family: 'CS ChatThaiUI' !important;
  word-wrap: break-word;
}

.textbusiness {
  margin-top: 1vh;
  font-family: 'CS ChatThaiUI' !important;
  word-wrap: break-word;
  /*width: 300px;*/
}

input[type=textprofile] {

  width: 100%;
  box-sizing: border-box;
  border: 2px solid #ccc;
  border-radius: 4px;
  font-size: 16px;
  background-color: white;
  /*background-image: url('../assets/image/group.png');*/
  background-position: 10px 10px;
  background-repeat: no-repeat;
  padding: 10px 10px 10px 10px;
  -webkit-transition: width 0.4s ease-in-out;
  transition: width 0.4s ease-in-out;
}

input[type=textprofile]:disabled {
  background: #cac9c9;
}

.header {
  display: block;
  font-size: 1.17em;
  -webkit-margin-before: 1em;
  -webkit-margin-after: 1em;
  -webkit-margin-start: 0px;
  -webkit-margin-end: 0px;
  margin: 40px 0 20px;
  padding-left: 20px;
  line-height: 1.3;
  font-weight: bold;
  font-size: 16px;
  position: relative;
  color: black !important;
}

.header::before {
  content: "";
  display: inline-block;
  position: absolute;
  top: 50%;
  -webkit-transform: translateY(-50%);
  transform: translateY(-50%);
  left: 0;
  width: 0;
  height: 32px;
  border-left: 4px solid #1a76d2;
}

.BreakWord {
  white-space: pre-wrap;
  word-break: break-all;
  word-break: break-word;
  word-wrap: break-word;
}

.SettingQr {
  display: -webkit-flex;
  display: flex;
}

.SettingQrImg {
  margin: 0 50px;
  position: relative;
}

.SettingQrNote {
  margin-bottom: 0;
  font-size: 13px;
}

.buttonedit {
  border: solid 1px #DEE5EC !important;
  box-sizing: border-box !important;
  margin-right: 0 !important;
  margin-left: 0 !important;
  text-align: center;
  font-weight: 400 !important;
  text-transform: none;
}

.EditAreaContFlex {
  display: -webkit-flex;
  display: flex;
  -webkit-justify-content: space-between;
  justify-content: space-between;
  -webkit-align-items: center;
  align-items: center;
}

.InputEdit {
  width: 100%;
  padding: 10px 15px;
  box-sizing: border-box;
  background-color: #fff;
  border: 1px solid #d2d8dd;
  border-radius: 4px;
}

.BGwhite {
  background-color: white !important;
}

.v-input--radio-group--row .v-input--radio-group__input {
  display: inline;
  flex-direction: row;
  flex-wrap: wrap;
}

div.v-input.v-input--selection-controls.v-input--radio-group.v-input--radio-group[data-v-6d08be0b][data-v-6d08be0b] {
  max-width: fit-content;
}

.theme--light.v-divider--vertical[data-v-6d08be0b] {
  border-color: rgb(87, 87, 88);
}

.v-divider--vertical {
  align-self: stretch;
  border: solid;
  border-width: 0 thin 0 0;
  display: inline-flex;
  height: inherit;
  min-height: 100%;
  max-height: 100%;
  max-width: 0;
  width: 0;
  vertical-align: text-bottom;

}

.divTextCenter {
  position: relative;
  text-align: center;
  color: #2562af;
}

.TextCenterPicture {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  font-size: 50px;
}

.divTextCenterAll {
  position: relative;
  text-align: center;
}

.TextCenterPictureAll {
  display: none;
}

.divTextCenterAll:hover .TextCenterPicture {
  display: none;
}

>>>.divTextCenterAll:hover .divTextCenter {
  opacity: 0.35 !important;
}

.divTextCenterAll:hover .TextCenterPictureAll {
  display: block;
  position: absolute;
  top: 50%;
  left: 50%;
  z-index: 100;
  transform: translate(-50%, -50%);
  font-size: 25px;
  color: black;
}


.cardClass {
  border-width: 1px;
  border-style: solid;
  border-radius: 15px;
  margin-left: 16px;
  margin-right: 16px;
  margin-top: 16px;
  margin-bottom: 16px;
}

h3 {
  display: inline-block;
  font-size: 1.17em;
  margin-block-start: 1em;
  margin-block-end: 1em;
  margin-inline-start: 20px;
  margin-inline-end: 0px;
  font-weight: bold;
  color: #2562af;
}

.spanStyle {
  font-size: 16px;
  /*font-style: oblique;*/
  /*   margin-top: 24px;
    margin-right: 20px;
    margin-bottom: 24px;
    margin-left: 20px;*/
}

.spanStyleTemplte {
  font-size: 16px;
  /*font-style: oblique;*/
  margin-top: 24px;
  margin-right: 20px;
  margin-bottom: 24px;
  margin-left: 20px;
}

.actionTemplateDetail {
  border-radius: 8px;
  border: #656565 1px solid;
  margin-left: 16px !important;
  margin-bottom: 16px !important;
}

.actionTemplateDetailEdit {
  border-bottom: #656565 1px solid;
  /*margin-bottom:16px !important;*/
  padding-top: 10px !important;
}

.labelAssignMenu {
  font-size: 16px;
  padding-right: 18px;
  padding-left: 18px;
  padding-top: 32px;
  padding-bottom: 26px;
}

.iconSizeWebview {
  cursor: pointer;
  margin-top: 15px;
  color: #7b7b7b;
  margin-right: 10px;
}

.headerColor {
  margin-top: 10px;
  color: #2562af !important;
}

>>>.accent--text {
  color: #2562af !important;
  caret-color: #2562af !important;
}

.vertical_center {
  margin: 0px;
  top: 50%;
  transform: translateY(-50%);
}

.btnTemplate {
  border-radius: 6px !important;
  color: white !important;
  background: #0e3660 !important;
  width: 150px;
  height: 35px;
  box-shadow: none !important;
}

.horizontal_center {
  margin: auto;
  justify-self: center;
  display: flex;
}

.EndpointVerbPost {
  top: -2px;
  display: inline-block;
  padding: 4px 6px;
  border: 1px solid #24446e;
  font-size: 0.75rem;
  font-weight: bold;
  line-height: 1em;
  border-radius: 4px;
  background-color: #24446e;
  color: #FFFFFF;
}

.EndpointSize {
  top: -2px;
  display: inline-block;
  padding: 4px 6px;
  border: 1px solid #5797e8;
  font-size: 0.75rem;
  font-weight: bold;
  line-height: 1em;
  border-radius: 4px;
  background-color: #5797e8;
  color: #FFFFFF;
}



.imageCover {
  background-position: center center !important;
  background-size: cover !important;
  background-repeat: initial;
  background-attachment: initial;
  background-origin: initial;
  background-clip: initial;
  background-color: initial;
}

.edit {
  margin-top: 12px;
  font-size: 1.4em;
  color: #2562af;
  cursor: pointer;
}

.trash {
  margin-top: 12px;
  font-size: 1.4em;
  color: red;
  cursor: pointer;
}

>>>.v-input--selection-controls {
  margin-top: 4px;
  padding-top: 4px;
}

.iconTypeWebview {
  cursor: pointer;
  margin-top: 5px;
  color: #7b7b7b;
  margin-right: 10px;
}

.typeProfile {
  /*border: 2px solid #2562af;*/
  border-radius: 10px;
  /*background: #2562af1f;*/
  background: #a6a8ab1f;
  padding: 5px;
}

>>>.v-messages {
  display: none !important;
}

/* .trash :hover {
} */

</style>



// WEBPACK FOOTER //
// src/components/managebot/bottommenu/edit_bottommenu.vue